import { Course } from './types';

export const allCourses: Course[] = [
{
    "id": "course-achievement-system-design",
    "title": "achievement system design",
    "summary": "AI时代课程：achievement system design",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-agent-operator",
    "title": "agent operator",
    "summary": "AI时代课程：agent operator",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-agile-fatigue-rd-team",
    "title": "agile fatigue rd team",
    "summary": "AI时代课程：agile fatigue rd team",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-action-item",
    "title": "ai action item",
    "summary": "AI时代课程：ai action item",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-action-item-v2",
    "title": "ai action item v2",
    "summary": "AI时代课程：ai action item v2",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-anomaly-detection",
    "title": "ai anomaly detection",
    "summary": "AI时代课程：ai anomaly detection",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-audit-explainability",
    "title": "ai audit explainability",
    "summary": "AI时代课程：ai audit explainability",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-capability-trainer",
    "title": "ai capability trainer",
    "summary": "AI时代课程：ai capability trainer",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-career-guide",
    "title": "ai career guide",
    "summary": "AI时代课程：ai career guide",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-disrupted-智能居中-人类在边缘",
    "title": "智能居中，人类在边缘",
    "summary": "当AI能以接近零成本完成信息处理和规则执行时，组织的决策权力正在从人类的中间层转移到算法的核心层。这不是工具的升级，而是组织权力结构的根本性重构。",
    "modules": 1,
    "audience": "管理者、总监、组织变革推动者",
    "tags": ["AI", "决策权", "组织架构"],
    "category": "disrupted",
    "articleId": "disrupted-智能居中-人类在边缘"
  },
  {
    "id": "course-ai-center-human-edge",
    "title": "ai center human edge",
    "summary": "AI时代课程：ai center human edge",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-conflict-resolution",
    "title": "ai conflict resolution",
    "summary": "AI时代课程：ai conflict resolution",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-content-auditor",
    "title": "ai content auditor",
    "summary": "AI时代课程：ai content auditor",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-content-strategist",
    "title": "ai content strategist",
    "summary": "AI时代课程：ai content strategist",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-cross-dept-coordinator",
    "title": "ai cross dept coordinator",
    "summary": "AI时代课程：ai cross dept coordinator",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-csm",
    "title": "ai csm",
    "summary": "AI时代课程：ai csm",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-customer-feedback",
    "title": "ai customer feedback",
    "summary": "AI时代课程：ai customer feedback",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-customer-service",
    "title": "ai customer service",
    "summary": "AI时代课程：ai customer service",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-customer-service-last-line",
    "title": "ai customer service last line",
    "summary": "AI时代课程：ai customer service last line",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-data-governance",
    "title": "ai data governance",
    "summary": "AI时代课程：ai data governance",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-decision-analyst",
    "title": "ai decision analyst",
    "summary": "AI时代课程：ai decision analyst",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-employee-care",
    "title": "ai employee care",
    "summary": "AI时代课程：ai employee care",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-employer-brand",
    "title": "ai employer brand",
    "summary": "AI时代课程：ai employer brand",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-employer-branding",
    "title": "ai employer branding",
    "summary": "AI时代课程：ai employer branding",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-era-corporate-culture-reshaping",
    "title": "ai era corporate culture reshaping",
    "summary": "AI时代课程：ai era corporate culture reshaping",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-ethics-officer",
    "title": "ai ethics officer",
    "summary": "AI时代课程：ai ethics officer",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-experience-designer",
    "title": "ai experience designer",
    "summary": "AI时代课程：ai experience designer",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-implementation-consultant",
    "title": "ai implementation consultant",
    "summary": "AI时代课程：ai implementation consultant",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-innovation-experimenter",
    "title": "ai innovation experimenter",
    "summary": "AI时代课程：ai innovation experimenter",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-interviewer-recruiter-path",
    "title": "ai interviewer recruiter path",
    "summary": "AI时代课程：ai interviewer recruiter path",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-knowledge",
    "title": "ai knowledge",
    "summary": "AI时代课程：ai knowledge",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-knowledge-extraction",
    "title": "ai knowledge extraction",
    "summary": "AI时代课程：ai knowledge extraction",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-knowledge-operator",
    "title": "ai knowledge operator",
    "summary": "AI时代课程：ai knowledge operator",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-layoff-decisions",
    "title": "ai layoff decisions",
    "summary": "AI时代课程：ai layoff decisions",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-meeting-prep",
    "title": "ai meeting prep",
    "summary": "AI时代课程：ai meeting prep",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-meeting-rehearsal",
    "title": "ai meeting rehearsal",
    "summary": "AI时代课程：ai meeting rehearsal",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-meeting-review",
    "title": "ai meeting review",
    "summary": "AI时代课程：ai meeting review",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-mentor-onboarding",
    "title": "ai mentor onboarding",
    "summary": "AI时代课程：ai mentor onboarding",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-monitoring-backfire",
    "title": "ai monitoring backfire",
    "summary": "AI时代课程：ai monitoring backfire",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-morning-meeting",
    "title": "ai morning meeting",
    "summary": "AI时代课程：ai morning meeting",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-native-org-structure",
    "title": "ai native org structure",
    "summary": "AI时代课程：ai native org structure",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-onboarding-customization",
    "title": "ai onboarding customization",
    "summary": "AI时代课程：ai onboarding customization",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-org-culture",
    "title": "ai org culture",
    "summary": "AI时代课程：ai org culture",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-org-learning",
    "title": "ai org learning",
    "summary": "AI时代课程：ai org learning",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-performance-auditor",
    "title": "ai performance auditor",
    "summary": "AI时代课程：ai performance auditor",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-performance-conversation",
    "title": "ai performance conversation",
    "summary": "AI时代课程：ai performance conversation",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-performance-fairness",
    "title": "ai performance fairness",
    "summary": "AI时代课程：ai performance fairness",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-performance-prediction",
    "title": "ai performance prediction",
    "summary": "AI时代课程：ai performance prediction",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-performance-revolution",
    "title": "ai performance revolution",
    "summary": "AI时代课程：ai performance revolution",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-performance-talk",
    "title": "ai performance talk",
    "summary": "AI时代课程：ai performance talk",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-personalized-education",
    "title": "ai personalized education",
    "summary": "AI时代课程：ai personalized education",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-product-manager",
    "title": "ai product manager",
    "summary": "AI时代课程：ai product manager",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-quality-assessor",
    "title": "ai quality assessor",
    "summary": "AI时代课程：ai quality assessor",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-realtime-translation-meetings",
    "title": "ai realtime translation meetings",
    "summary": "AI时代课程：ai realtime translation meetings",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-recommendation-choice",
    "title": "ai recommendation choice",
    "summary": "AI时代课程：ai recommendation choice",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-recruitment",
    "title": "ai recruitment",
    "summary": "AI时代课程：ai recruitment",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-recruitment-bias",
    "title": "ai recruitment bias",
    "summary": "AI时代课程：ai recruitment bias",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-reshaping-team-planning",
    "title": "ai reshaping team planning",
    "summary": "AI时代课程：ai reshaping team planning",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-resume-hr-value",
    "title": "ai resume hr value",
    "summary": "AI时代课程：ai resume hr value",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-resume-screening-hr-value",
    "title": "ai resume screening hr value",
    "summary": "AI时代课程：ai resume screening hr value",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-salary-negotiation",
    "title": "ai salary negotiation",
    "summary": "AI时代课程：ai salary negotiation",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-scheduling-wellbeing",
    "title": "ai scheduling wellbeing",
    "summary": "AI时代课程：ai scheduling wellbeing",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-scoring-fairness",
    "title": "ai scoring fairness",
    "summary": "AI时代课程：ai scoring fairness",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-security-officer",
    "title": "ai security officer",
    "summary": "AI时代课程：ai security officer",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-skill-gap",
    "title": "ai skill gap",
    "summary": "AI时代课程：ai skill gap",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-strategic-planning-role",
    "title": "ai strategic planning role",
    "summary": "AI时代课程：ai strategic planning role",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-strategy-analyst",
    "title": "ai strategy analyst",
    "summary": "AI时代课程：ai strategy analyst",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-task-allocation",
    "title": "ai task allocation",
    "summary": "AI时代课程：ai task allocation",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-trainer",
    "title": "ai trainer",
    "summary": "AI时代课程：ai trainer",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-trainer-career-path",
    "title": "ai trainer career path",
    "summary": "AI时代课程：ai trainer career path",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-trainer-competency",
    "title": "ai trainer competency",
    "summary": "AI时代课程：ai trainer competency",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-trainer-role",
    "title": "ai trainer role",
    "summary": "AI时代课程：ai trainer role",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-trainer-tech-iteration",
    "title": "ai trainer tech iteration",
    "summary": "AI时代课程：ai trainer tech iteration",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-trainer-toolchain",
    "title": "ai trainer toolchain",
    "summary": "AI时代课程：ai trainer toolchain",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-trainer-transition",
    "title": "ai trainer transition",
    "summary": "AI时代课程：ai trainer transition",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-training-evaluation",
    "title": "ai training evaluation",
    "summary": "AI时代课程：ai training evaluation",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-turnover-prediction",
    "title": "ai turnover prediction",
    "summary": "AI时代课程：ai turnover prediction",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-virtual-assistant",
    "title": "ai virtual assistant",
    "summary": "AI时代课程：ai virtual assistant",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-ai-workflow-designer",
    "title": "ai workflow designer",
    "summary": "AI时代课程：ai workflow designer",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-atm-model-synergy",
    "title": "atm model synergy",
    "summary": "AI时代课程：atm model synergy",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-avoid-ai-discrimination",
    "title": "avoid ai discrimination",
    "summary": "AI时代课程：avoid ai discrimination",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-basic-customer-service-outsourcing-end",
    "title": "basic customer service outsourcing end",
    "summary": "AI时代课程：basic customer service outsourcing end",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-basic-financial-report-end",
    "title": "basic financial report end",
    "summary": "AI时代课程：basic financial report end",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-bonus-motivation-paradox",
    "title": "bonus motivation paradox",
    "summary": "AI时代课程：bonus motivation paradox",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-capacity-deployment",
    "title": "capacity deployment",
    "summary": "AI时代课程：capacity deployment",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-capacity-deployment-v2",
    "title": "capacity deployment v2",
    "summary": "AI时代课程：capacity deployment v2",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-coaching-ai-assistant",
    "title": "coaching ai assistant",
    "summary": "AI时代课程：coaching ai assistant",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-coaching-digital",
    "title": "coaching digital",
    "summary": "AI时代课程：coaching digital",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-coaching-digital-2",
    "title": "coaching digital 2",
    "summary": "AI时代课程：coaching digital 2",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-conflict-resolution-ai",
    "title": "冲突解决与AI辅助",
    "category": "stable",
    "quiz_url": "/courses/courses/course-conflict-resolution-ai/quiz.html",
    "handbook_url": "/courses/courses/course-conflict-resolution-ai/handbook.html",
    "articleId": "stable-conflict-resolution-ai",
    "summary": "AI时代冲突解决的分层处理策略",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "冲突解决",
      "AI管理",
      "团队协作"
    ]
  },
  {
    "id": "course-consulting-knowledge-mgmt",
    "title": "consulting knowledge mgmt",
    "summary": "AI时代课程：consulting knowledge mgmt",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-cross-cultural-ai",
    "title": "cross cultural ai",
    "summary": "AI时代课程：cross cultural ai",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-cross-culture-management",
    "title": "cross culture management",
    "summary": "AI时代课程：cross culture management",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-cross-culture-mgmt",
    "title": "cross culture mgmt",
    "summary": "AI时代课程：cross culture mgmt",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-data-entry-validator",
    "title": "data entry validator",
    "summary": "AI时代课程：data entry validator",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-data-intuition-decision",
    "title": "data intuition decision",
    "summary": "AI时代课程：data intuition decision",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-data-privacy-trust",
    "title": "data privacy trust",
    "summary": "AI时代课程：data privacy trust",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-data-vs-intuition",
    "title": "data vs intuition",
    "summary": "AI时代课程：data vs intuition",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-decision-making",
    "title": "decision making",
    "summary": "AI时代课程：decision making",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-digital-employee-admin",
    "title": "digital employee admin",
    "summary": "AI时代课程：digital employee admin",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-digital-org-memory",
    "title": "digital org memory",
    "summary": "AI时代课程：digital org memory",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-dynamic-learning-content",
    "title": "dynamic learning content",
    "summary": "AI时代课程：dynamic learning content",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-feedback-art-science",
    "title": "feedback art science",
    "summary": "AI时代课程：feedback art science",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-gamification-ai-training",
    "title": "gamification ai training",
    "summary": "AI时代课程：gamification ai training",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-gamification-pbl-sdt",
    "title": "gamification pbl sdt",
    "summary": "AI时代课程：gamification pbl sdt",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-gamified-goal-setting",
    "title": "gamified goal setting",
    "summary": "AI时代课程：gamified goal setting",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-growth-mindset-gamification",
    "title": "growth mindset gamification",
    "summary": "AI时代课程：growth mindset gamification",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-human-ai-collab-designer",
    "title": "human ai collab designer",
    "summary": "AI时代课程：human ai collab designer",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-human-ai-collaboration",
    "title": "human ai collaboration",
    "summary": "AI时代课程：human ai collaboration",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-human-ai-trust",
    "title": "human ai trust",
    "summary": "AI时代课程：human ai trust",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-hybrid-work-algo-org",
    "title": "hybrid work algo org",
    "summary": "AI时代课程：hybrid work algo org",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-incentive-system-evolution",
    "title": "incentive system evolution",
    "summary": "AI时代课程：incentive system evolution",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-intelligence-orchestration-layer",
    "title": "intelligence orchestration layer",
    "summary": "AI时代课程：intelligence orchestration layer",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-interactive-course-design",
    "title": "interactive course design",
    "summary": "AI时代课程：interactive course design",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-intrinsic-learning-motivation",
    "title": "intrinsic learning motivation",
    "summary": "AI时代课程：intrinsic learning motivation",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-key-client-trust-ai",
    "title": "key client trust ai",
    "summary": "AI时代课程：key client trust ai",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-knowledge-graph-org-learning",
    "title": "knowledge graph org learning",
    "summary": "AI时代课程：knowledge graph org learning",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-leader-ai-literacy",
    "title": "leader ai literacy",
    "summary": "AI时代课程：leader ai literacy",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-leader-ai-literacy-v2",
    "title": "leader ai literacy v2",
    "summary": "AI时代课程：leader ai literacy v2",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-learning-effect-behavior",
    "title": "learning effect behavior",
    "summary": "AI时代课程：learning effect behavior",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-learning-feedback-realtime",
    "title": "learning feedback realtime",
    "summary": "AI时代课程：learning feedback realtime",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-low-end-copywriting-outsourcing-end",
    "title": "low end copywriting outsourcing end",
    "summary": "AI时代课程：low end copywriting outsourcing end",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-low-end-data-entry-end",
    "title": "low end data entry end",
    "summary": "AI时代课程：low end data entry end",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-manus-task-driven",
    "title": "manus task driven",
    "summary": "AI时代课程：manus task driven",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-mba-dilemma",
    "title": "mba dilemma",
    "summary": "AI时代课程：mba dilemma",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-mentor-ai-matching",
    "title": "mentor ai matching",
    "summary": "AI时代课程：mentor ai matching",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-mentorship-evolution",
    "title": "mentorship evolution",
    "summary": "AI时代课程：mentorship evolution",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-middle-management-twilight",
    "title": "middle management twilight",
    "summary": "AI时代课程：middle management twilight",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-okr-ai-integration",
    "title": "okr ai integration",
    "summary": "AI时代课程：okr ai integration",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-onboarding",
    "title": "onboarding",
    "summary": "AI时代课程：onboarding",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-one-person-company",
    "title": "one person company",
    "summary": "AI时代课程：one person company",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-org-evolution-accelerator",
    "title": "org evolution accelerator",
    "summary": "AI时代课程：org evolution accelerator",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-org-evolution-accelerator-v2",
    "title": "org evolution accelerator v2",
    "summary": "AI时代课程：org evolution accelerator v2",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-org-memory-digital",
    "title": "org memory digital",
    "summary": "AI时代课程：org memory digital",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-org-memory-digital-v2",
    "title": "org memory digital v2",
    "summary": "AI时代课程：org memory digital v2",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-org-resilience-ai-warning",
    "title": "org resilience ai warning",
    "summary": "AI时代课程：org resilience ai warning",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-org-resilience-warning",
    "title": "org resilience warning",
    "summary": "AI时代课程：org resilience warning",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-organizational-knowledge-ai-preservation",
    "title": "organizational knowledge ai preservation",
    "summary": "AI时代课程：organizational knowledge ai preservation",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-pbl-deep-motivation",
    "title": "pbl deep motivation",
    "summary": "AI时代课程：pbl deep motivation",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-phone-customer-service-end",
    "title": "phone customer service end",
    "summary": "AI时代课程：phone customer service end",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-player-coach",
    "title": "player coach",
    "summary": "AI时代课程：player coach",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-points-exchange-mechanism",
    "title": "points exchange mechanism",
    "summary": "AI时代课程：points exchange mechanism",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-promotion-transparency",
    "title": "promotion transparency",
    "summary": "AI时代课程：promotion transparency",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-prompt-engineer",
    "title": "prompt engineer",
    "summary": "AI时代课程：prompt engineer",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-psychological-safety-ai",
    "title": "psychological safety ai",
    "summary": "AI时代课程：psychological safety ai",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-punishment-to-learning",
    "title": "punishment to learning",
    "summary": "AI时代课程：punishment to learning",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-quality-control-responsibility",
    "title": "quality control responsibility",
    "summary": "AI时代课程：quality control responsibility",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-realtime-decision-system",
    "title": "realtime decision system",
    "summary": "AI时代课程：realtime decision system",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-reduce-meetings",
    "title": "reduce meetings",
    "summary": "AI时代课程：reduce meetings",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-remote-team",
    "title": "remote team",
    "summary": "AI时代课程：remote team",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-remote-team-collab",
    "title": "remote team collab",
    "summary": "AI时代课程：remote team collab",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-resume-screening-human-intuition",
    "title": "resume screening human intuition",
    "summary": "AI时代课程：resume screening human intuition",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-reward-kills-passion",
    "title": "reward kills passion",
    "summary": "AI时代课程：reward kills passion",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-reward-kills-passion-v2",
    "title": "reward kills passion v2",
    "summary": "AI时代课程：reward kills passion v2",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-startup-ai-toolchain",
    "title": "startup ai toolchain",
    "summary": "AI时代课程：startup ai toolchain",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-startup-quick-validation",
    "title": "startup quick validation",
    "summary": "AI时代课程：startup quick validation",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-strategic-decision-human",
    "title": "strategic decision human",
    "summary": "AI时代课程：strategic decision human",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-stress-ai-warning",
    "title": "stress ai warning",
    "summary": "AI时代课程：stress ai warning",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-talent-pipeline-growth",
    "title": "talent pipeline growth",
    "summary": "AI时代课程：talent pipeline growth",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-team-cohesion-gamification",
    "title": "team cohesion gamification",
    "summary": "AI时代课程：team cohesion gamification",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-team-emotion-ai",
    "title": "team emotion ai",
    "summary": "AI时代课程：team emotion ai",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-translation-quality-guardian",
    "title": "translation quality guardian",
    "summary": "AI时代课程：translation quality guardian",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-volunteer-gamification",
    "title": "volunteer gamification",
    "summary": "AI时代课程：volunteer gamification",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-volunteer-gamification-v2",
    "title": "volunteer gamification v2",
    "summary": "AI时代课程：volunteer gamification v2",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "AI",
      "组织"
    ],
    "category": "disrupted",
    "articleId": null
  },
  {
    "id": "course-translation-end",
    "title": "初级翻译岗位消失：当AI能读懂上下文",
    "summary": "翻译能力从人力资本变成基础设施，初级翻译岗位消失，但翻译能力换了一种存在方式。",
    "articleId": "art-301",
    "category": "eliminated",
    "tags": [
      "翻译",
      "岗位消失",
      "能力商品化"
    ],
    "quiz_url": "/courses/courses/course-translation-end/quiz.html",
    "handbook_url": "/courses/courses/course-translation-end/handbook.html"
  },
  {
    "id": "course-layout-outsource-end",
    "title": "基础排版外包消失：设计从技能变成对话",
    "summary": "设计能力从技能变成了对话，AI让排版门槛消失，但设计思维和品牌判断仍在。",
    "articleId": "art-302",
    "category": "eliminated",
    "tags": [
      "设计",
      "排版外包",
      "能力交互化"
    ],
    "quiz_url": "/courses/courses/course-layout-outsource-end/quiz.html",
    "handbook_url": "/courses/courses/course-layout-outsource-end/handbook.html"
  },
  {
    "id": "course-seo-executive-end",
    "title": "简单SEO执行岗位消失：当AI能读懂搜索引擎的心思",
    "summary": "搜索引擎自身AI化后，套路化SEO失效。SEO思维从优化排名变成让AI引用。",
    "articleId": "art-303",
    "category": "eliminated",
    "tags": [
      "SEO",
      "GEO",
      "搜索引擎",
      "AI替代"
    ],
    "quiz_url": "/courses/courses/course-seo-executive-end/quiz.html",
    "handbook_url": "/courses/courses/course-seo-executive-end/handbook.html"
  },
  {
    "id": "course-accounting-entry-end",
    "title": "基础会计录入消失",
    "summary": "记账能力变成基础设施，会计能力从执行层上移到判断层",
    "articleId": "art-304",
    "category": "eliminated",
    "tags": [
      "会计",
      "AI替代"
    ],
    "quiz_url": "/courses/courses/course-accounting-entry-end/quiz.html",
    "handbook_url": "/courses/courses/course-accounting-entry-end/handbook.html"
  },
  {
    "id": "course-customer-service-reply-end",
    "title": "简单客服回复消失",
    "summary": "标准化回复变成基础设施，客服能力从回复层上移到沟通层",
    "articleId": "art-305",
    "category": "eliminated",
    "tags": [
      "客服",
      "AI替代"
    ],
    "quiz_url": "/courses/courses/course-customer-service-reply-end/quiz.html",
    "handbook_url": "/courses/courses/course-customer-service-reply-end/handbook.html"
  },
  {
    "id": "course-market-research-end",
    "title": "基础市场调研消失",
    "summary": "信息获取变成基础设施，调研能力从收集层上移到判断层",
    "articleId": "art-306",
    "category": "eliminated",
    "tags": [
      "调研",
      "AI替代"
    ],
    "quiz_url": "/courses/courses/course-market-research-end/quiz.html",
    "handbook_url": "/courses/courses/course-market-research-end/handbook.html"
  },
  {
    "id": "course-resume-screening-end",
    "title": "基础简历筛选消失",
    "summary": "信息匹配变成基础设施，招聘能力从筛选层上移到识人层",
    "articleId": "art-307",
    "category": "eliminated",
    "tags": [
      "招聘",
      "AI替代"
    ],
    "quiz_url": "/courses/courses/course-resume-screening-end/quiz.html",
    "handbook_url": "/courses/courses/course-resume-screening-end/handbook.html"
  },
  {
    "id": "course-contract-review-end",
    "title": "基础合同审核消失",
    "summary": "条款匹配变成基础设施，法务能力从审核层上移到判断层",
    "articleId": "art-308",
    "category": "eliminated",
    "tags": [
      "法务",
      "AI替代"
    ],
    "quiz_url": "/courses/courses/course-contract-review-end/quiz.html",
    "handbook_url": "/courses/courses/course-contract-review-end/handbook.html"
  },
  {
    "id": "course-meeting-notes-end",
    "title": "基础会议纪要消失",
    "summary": "信息记录变成基础设施，会议管理能力从记录层上移到推动层",
    "articleId": "art-308",
    "category": "eliminated",
    "tags": [
      "行政",
      "AI替代"
    ],
    "quiz_url": "/courses/courses/course-meeting-notes-end/quiz.html",
    "handbook_url": "/courses/courses/course-meeting-notes-end/handbook.html"
  },
  {
    "id": "course-reimbursement-audit-end",
    "title": "基础报销审核消失",
    "summary": "费用核对能力变成基础设施",
    "articleId": "art-309",
    "category": "eliminated",
    "tags": [
      "报销",
      "AI替代"
    ],
    "quiz_url": "/courses/courses/course-reimbursement-audit-end/quiz.html",
    "handbook_url": "/courses/courses/course-reimbursement-audit-end/handbook.html"
  },
  {
    "id": "course-employee-care-stable",
    "title": "员工关怀：AI能分析数据，但关怀需要人",
    "summary": "AI能做员工情绪预警，但关怀的执行需要人的判断和温度。探索AI时代员工关怀的新方式。",
    "modules": 1,
    "audience": "培训师、管理者、HR",
    "tags": [
      "员工关怀",
      "AI时代",
      "人才管理"
    ],
    "category": "stable",
    "articleId": "art-311",
    "quiz_url": "/courses/courses/course-employee-care-stable/quiz.html",
    "handbook_url": "/courses/courses/course-employee-care-stable/handbook.html"
  },
  {
    "id": "course-budget-ai-disrupted",
    "title": "用AI做预算编制：从拍脑袋到算明白",
    "summary": "AI让预算编制从政治博弈变成数据对话。探索AI时代的财务预测新方式。",
    "modules": 1,
    "audience": "培训师、管理者、财务负责人",
    "tags": [
      "预算编制",
      "AI财务",
      "资源分配"
    ],
    "category": "disrupted",
    "articleId": "art-315"
  },
  {
    "id": "course-task-allocation-disrupted",
    "title": "用AI做任务分配和优先级：从直觉判断到数据驱动",
    "summary": "AI改变任务分配方式，但核心判断在人。探索AI时代的任务管理新模式。",
    "modules": 1,
    "audience": "培训师、管理者、项目经理",
    "tags": [
      "任务管理",
      "AI协作",
      "团队效率"
    ],
    "category": "disrupted",
    "articleId": "art-313",
    "quiz_url": "/courses/courses/course-task-allocation-disrupted/quiz.html",
    "handbook_url": "/courses/courses/course-task-allocation-disrupted/handbook.html"
  },
  {
    "id": "course-team-ritual-stable",
    "title": "AI时代的团队仪式感：算法建不了归属感",
    "summary": "AI可以触发仪式，但归属感只能人来创造。探索AI时代如何建立团队归属感。",
    "modules": 1,
    "audience": "培训师、管理者",
    "tags": [
      "团队文化",
      "归属感",
      "仪式感"
    ],
    "category": "stable",
    "articleId": "art-312",
    "quiz_url": "/courses/courses/course-team-ritual-stable/quiz.html",
    "handbook_url": "/courses/courses/course-team-ritual-stable/handbook.html"
  },
  {
    "id": "course-data-insight-disrupted",
    "title": "AI数据洞察：决策从\"拍脑袋\"到\"看数据\"",
    "summary": "AI改变决策的起点，但决策本身仍是人的事。探索数据驱动的决策新方式。",
    "modules": 1,
    "audience": "培训师、管理者",
    "tags": [
      "数据洞察",
      "AI决策",
      "管理变革"
    ],
    "category": "disrupted",
    "articleId": "art-314",
    "quiz_url": "/courses/courses/course-data-insight-disrupted/quiz.html",
    "handbook_url": "/courses/courses/course-data-insight-disrupted/handbook.html"
  },
  {
    "id": "course-trust-building",
    "title": "信任建立与人际关系",
    "category": "stable",
    "quiz_url": "/courses/courses/course-trust-building/quiz.html",
    "handbook_url": "/courses/courses/course-trust-building/handbook.html",
    "articleId": "stable-trust-building-ai",
    "summary": "AI时代信任建立的底层逻辑与实践方法",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "信任",
      "人际关系",
      "AI管理"
    ]
  },
  {
    "id": "course-empathy-ai-boundary",
    "title": "同理心与AI边界",
    "category": "stable",
    "quiz_url": "/courses/courses/course-empathy-ai-boundary/quiz.html",
    "handbook_url": "/courses/courses/course-empathy-ai-boundary/handbook.html",
    "articleId": "stable-empathy-ai-boundary",
    "summary": "AI时代同理心能力的边界与培养",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
      "同理心",
      "AI管理",
      "情绪智力"
    ]
  },
  {
    "id": "course-employee-care-ai",
    "title": "员工关怀与AI辅助",
    "category": "stable",
    "quiz_url": "/courses/courses/course-employee-care-ai/quiz.html",
    "handbook_url": "/courses/courses/course-employee-care-ai/handbook.html",
    "articleId": "stable-employee-care-ai",
    "summary": "AI时代员工关怀的边界与实践",
    "modules": 1,
    "audience": "管理者、HR",
    "tags": [
      "员工关怀",
      "AI管理",
      "人性化管理"
    ]
  },
  {
    "id": "course-ai-era-culture-reshape",
    "title": "AI时代的企业文化重塑",
    "category": "stable",
    "quiz_url": "/courses/courses/course-ai-era-culture-reshape/quiz.html",
    "handbook_url": "/courses/courses/course-ai-era-culture-reshape/handbook.html",
    "articleId": "stable-ai-era-culture-reshape",
    "summary": "AI改变不了企业文化，但改变了谁来承载文化",
    "modules": 1,
    "audience": "管理者、企业文化负责人",
    "tags": ["企业文化", "AI", "组织", "管理"]
  },
  {
    "id": "course-org-identity-ai-era",
    "title": "AI时代的组织认同感",
    "category": "stable",
    "quiz_url": "/courses/courses/course-org-identity-ai-era/quiz.html",
    "handbook_url": "/courses/courses/course-org-identity-ai-era/handbook.html",
    "articleId": "stable-org-identity-ai-era",
    "summary": "归属感为什么算法给不了",
    "modules": 1,
    "audience": "管理者、HR",
    "tags": ["组织认同感", "归属感", "AI", "管理"]
  },
  {
    "id": "course-employee-satisfaction-ai",
    "title": "员工满意度调研的AI边界",
    "category": "stable",
    "quiz_url": "/courses/courses/course-employee-satisfaction-ai/quiz.html",
    "handbook_url": "/courses/courses/course-employee-satisfaction-ai/handbook.html",
    "articleId": "stable-employee-satisfaction-ai",
    "summary": "AI能收集数据，但理解需要人",
    "modules": 1,
    "audience": "管理者、HR",
    "tags": ["员工满意度", "AI调研", "管理"]
  },
  {
    "id": "course-competitive-analysis-ai",
    "title": "用AI做竞品分析",
    "category": "disrupted",
    "quiz_url": "/courses/courses/course-competitive-analysis-ai/quiz.html",
    "handbook_url": "/courses/courses/course-competitive-analysis-ai/handbook.html",
    "articleId": "disrupted-competitive-analysis-ai",
    "summary": "从拍脑袋到数据驱动",
    "modules": 1,
    "audience": "管理者、产品负责人",
    "tags": ["竞品分析", "AI", "决策"]
  },
  {
    "id": "course-agile-decision-ai",
    "title": "AI驱动的敏捷决策",
    "category": "disrupted",
    "quiz_url": "/courses/courses/course-agile-decision-ai/quiz.html",
    "handbook_url": "/courses/courses/course-agile-decision-ai/handbook.html",
    "articleId": "disrupted-agile-decision-ai",
    "summary": "当速度成为竞争优势",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["敏捷决策", "AI", "组织"]
  },
  {
    "id": "course-stable-team-cohesion-ai-era",
    "title": "AI时代的团队凝聚力",
    "category": "stable",
    "quiz_url": "/courses/courses/course-stable-team-cohesion-ai-era/quiz.html",
    "handbook_url": "/courses/courses/course-stable-team-cohesion-ai-era/handbook.html",
    "articleId": "stable-team-cohesion-ai-era",
    "summary": "为什么'一起吃饭'比'高效协作'更重要",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["团队凝聚力", "AI时代", "关系"]
  },
  {
    "id": "course-eliminated-attendance-management-exit",
    "title": "AI让'考勤管理'退出历史舞台",
    "category": "eliminated",
    "quiz_url": "/courses/courses/course-eliminated-attendance-management-exit/quiz.html",
    "handbook_url": "/courses/courses/course-eliminated-attendance-management-exit/handbook.html",
    "articleId": "eliminated-attendance-management-exit",
    "summary": "从'你迟到了'到'你完成了什么'",
    "modules": 1,
    "audience": "管理者、HR",
    "tags": ["考勤", "AI管理", "消失"]
  },
  {
    "id": "course-created-internal-ai-consultant",
    "title": "AI让'内部顾问'成为新职业",
    "category": "created",
    "quiz_url": "/courses/courses/course-created-internal-ai-consultant/quiz.html",
    "handbook_url": "/courses/courses/course-created-internal-ai-consultant/handbook.html",
    "articleId": "created-internal-ai-consultant",
    "summary": "企业内部AI能力的共享中心",
    "modules": 1,
    "audience": "管理者、AI负责人",
    "tags": ["AI顾问", "新职业", "AI落地"]
  },
  {
    "id": "course-disrupted-customer-service-human-ai-relay",
    "title": "AI重写客户服务规则",
    "category": "disrupted",
    "quiz_url": "/courses/courses/course-disrupted-customer-service-human-ai-relay/quiz.html",
    "handbook_url": "/courses/courses/course-disrupted-customer-service-human-ai-relay/handbook.html",
    "articleId": "disrupted-customer-service-human-ai-relay",
    "summary": "不是AI替代人，是人机接力赛",
    "modules": 1,
    "audience": "客服管理者、运营负责人",
    "tags": ["客户服务", "人机接力", "AI"]
  },
  {
    "id": "course-disrupted-improvisational-leadership-ai-era",
    "title": "AI时代的即兴领导力",
    "category": "disrupted",
    "quiz_url": "/courses/courses/course-disrupted-improvisational-leadership-ai-era/quiz.html",
    "handbook_url": "/courses/courses/course-disrupted-improvisational-leadership-ai-era/handbook.html",
    "articleId": "disrupted-improvisational-leadership-ai-era",
    "summary": "当计划不再有价值，什么才重要",
    "modules": 1,
    "audience": "管理者、创业者",
    "tags": ["即兴领导力", "计划", "AI时代"]
  },
  {
    "id": "course-你的周会-为什么越开越累",
    "title": "你的周会，为什么越开越累？",
    "summary": "你有没有这种感觉：周一早上，邮件已经堆成山，突然弹出一个会议邀请——周会。你深吸一口气，准备好咖啡，准时进入会议室。然后，两个小时过去了，你心力交瘁，却想不起来刚才到底决定了什么。  这不是你的问题。这是大多数公司周会的常态。  **周会为",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-你的周会-为什么越开越累"
  },

  {
    "id": "course-你的会议纪要-是人在写还是ai在写",
    "title": "你的会议纪要，是人在写还是AI在写？",
    "summary": "你有没有注意过一个现象？  以前开完会，总有人主动或者被指派去写会议纪要。那个人往往很头疼：要回忆大家说了什么，要整理分歧和共识，要列出action items，还要发给所有人确认。有时候一场会开完，整理纪要比开会本身还累。  现在呢？很多",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "会议"],
    "category": "洞察",
    "articleId": "disrupted-你的会议纪要-是人在写还是ai在写"
  },

  {
    "id": "course-你的季度汇报-为什么还停在ppt时代",
    "title": "你的季度汇报，为什么还停在PPT时代？",
    "summary": "---  你有没有经历过这样的场景？  季度末，会议室。投影仪亮起，PPT翻到第15页。你打了个哈欠，偷偷看了下手机。台上的人在讲“同比增长3.2个百分点”，“渠道覆盖率提升至87%”，旁边的人在点头，你不知道他们在点头什么。  结束后，你",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-你的季度汇报-为什么还停在ppt时代"
  },

  {
    "id": "course-开会还要本人到场-是不是太out了",
    "title": "开会还要本人到场，是不是太Out了？",
    "summary": "你有没有遇到过这种情况？  你早上九点有个会，下午两点有个会，晚上六点还有个会。三个会分布在不同楼层、不同大楼、不同城市。你算了一下，今天花在路上的时间加起来有两个小时。你坐在第三个会议室里的时候，已经想不起来第一个会上说了什么。  但你没",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-开会还要本人到场-是不是太out了"
  },

  {
    "id": "course-用ai抓摸鱼-反而会让努力的人离开",
    "title": "用AI抓摸鱼，反而会让努力的人离开？",
    "summary": "## 痛点引入  很多老板都在想一个问题：员工有没有在摸鱼？  这个问题，在AI时代变得特别好回答。现在有大量工具可以追踪员工的在线状态、邮件回复速度、文档编辑记录。甚至有专门的“摸鱼检测”系统，会在你离开电脑超过10分钟时自动标记。  听",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-用ai抓摸鱼-反而会让努力的人离开"
  },

  {
    "id": "course-ai做的绩效面谈-员工真的能接受吗",
    "title": "AI做的绩效面谈，员工真的能接受吗？",
    "summary": "你有没有想过，有一天帮你做绩效面谈的，可能不是人？  这不是科幻。现在很多公司已经在用AI做绩效面谈的准备、分析、甚至直接参与对话。但一个新问题来了：员工真的能接受吗？  今天聊聊这个事。  ## 01 员工在担心什么？  去年，Gartn",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "绩效"],
    "category": "洞察",
    "articleId": "disrupted-ai做的绩效面谈-员工真的能接受吗"
  },

  {
    "id": "course-ai做的绩效分析更准确-为什么员工反而更不满意",
    "title": "AI做的绩效分析更准确，为什么员工反而更不满意？",
    "summary": "你有没有这种感觉？  公司花了几十万买了AI绩效分析系统，数据更全面了，打分更客观了，报告更详细了。结果呢？员工满意度反而下降了。  老板们想不通。预算也花了，工具也上了，流程也改了。怎么越改越糟？  我告诉你一个反直觉的真相：**AI绩效",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "绩效"],
    "category": "洞察",
    "articleId": "disrupted-ai做的绩效分析更准确-为什么员工反而更不满意"
  },

  {
    "id": "course-你的绩效报表已经够好看了-为什么ai还要多此一举",
    "title": "你的绩效报表已经够好看了，为什么AI还要多此一举？",
    "summary": "你有没有这种感觉？  每年做绩效数据可视化，图表越来越漂亮，颜色越来越丰富，报表越来越精致。老板看了点头，员工看了无感。数据还是那个数据，只是换了个更好看的包装。  传统的数据可视化，已经把“好看”这件事做到极致了。  但我告诉你一个反直觉",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "绩效"],
    "category": "洞察",
    "articleId": "disrupted-你的绩效报表已经够好看了-为什么ai还要多此一举"
  },

  {
    "id": "course-ai绩效教练-私人定制成长方案",
    "title": "AI绩效教练：私人定制成长方案",
    "summary": "**核心观点**：绩效面谈是\\\"事后补救\\\"，真正的成长需要\\\"每日教练\\\"。AI让每个员工都拥有一位24小时在线的私教——而且，这位私教从不敷衍。  ---  ## 01 为什么绩效面谈总是走形式  年底了，张经理坐在会议室里，对面是小刘，这是他",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "绩效"],
    "category": "洞察",
    "articleId": "disrupted-ai绩效教练-私人定制成长方案"
  },

  {
    "id": "course-绩效体系被ai重构之后-为什么员工反而更焦虑了",
    "title": "绩效体系被AI重构之后，为什么员工反而更焦虑了？",
    "summary": "你有没有见过这样的场景？  一家互联网公司的HR总监兴奋地向CEO汇报：“我们上线了全新的AI绩效系统！从目标设定到过程追踪，再到最终评估，全部自动化。员工每天的行为数据都会被实时采集，系统会自动生成评分和建议。年度绩效评估周期从三个月缩短",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "绩效"],
    "category": "洞察",
    "articleId": "disrupted-绩效体系被ai重构之后-为什么员工反而更焦虑了"
  },

  {
    "id": "course-靠记忆做复盘-你的企业亏了多少",
    "title": "靠记忆做复盘，你的企业亏了多少？",
    "summary": "你有没有过这样的经历：开完一场复盘会，两周后回头问大家“上次说的action item完成了吗”，结果一半人已经忘了当时说了什么？  这不是他们的错。这是人类大脑的基本机制。  ## 记忆力靠不住，这不是观点是事实  我们来做个实验。你现在",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-靠记忆做复盘-你的企业亏了多少"
  },

  {
    "id": "course-ai筛选简历-hr的价值重估",
    "title": "AI筛选简历：HR的价值重估",
    "summary": "你有没有注意到一个趋势？  以前招聘季，HR最忙的时候是看简历。每天几百份简历，每份都要花几分钟扫一眼，看看学历、经历、跳槽频率、薪资预期。筛完一轮，符合条件的可能不到十分之一。这项工作重复性高、决策简单，却占用了HR大量时间。  现在不一",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-ai筛选简历-hr的价值重估"
  },

  {
    "id": "course-ai面试官来了-招聘官何去何从",
    "title": "AI面试官来了，招聘官何去何从",
    "summary": "你有没有这种感觉：忙了一天，筛了几十份简历，打了十几通电话，约了五个候选人面试——结果入职三个月，发现招错了人。  这不是你眼力不行。这是招聘本身的问题。  **为什么花了那么多时间，还是招不对人？** 不是因为你不够努力，而是因为传统的招",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "招聘"],
    "category": "洞察",
    "articleId": "disrupted-ai面试官来了-招聘官何去何从"
  },

  {
    "id": "course-用ai做候选人匹配度分析-靠谱吗",
    "title": "用AI做候选人匹配度分析，靠谱吗？",
    "summary": "招聘季，你可能收到几百份简历。HR的办法通常是这样的：先筛关键词——本科、三年经验、Python、985。再让猎头推荐几份觉得\\\"不错\\\"的。然后约面试，聊一个小时，凭感觉判断这个人行不行。  这个流程，看起来很合理。  但你有没有发现：**你",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-用ai做候选人匹配度分析-靠谱吗"
  },

  {
    "id": "course-新员工入职-ai导师时代",
    "title": "新员工入职：AI导师时代",
    "summary": "你有没有遇到过这种情况：入职第一天，工牌还没捂热，就被拉进一个群，丢过来十几份文档，然后老员工扔下一句\\\"先看着，有问题再问\\\"——然后你发现，没人真的有时间回答你的问题。  三个月后，你还是没搞清楚报销流程该找谁、绩效申诉该怎么走、跨部门协作",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-新员工入职-ai导师时代"
  },

  {
    "id": "course-ai入职培训的定制化可能",
    "title": "AI入职培训的定制化可能",
    "summary": "你有没有见过这种场景：新员工入职第一天，领到一本厚厚的员工手册，看完不知所云；参加三天的集中培训，内容全是通用技能，和自己实际要做的工作关系不大；一个月后正式上手，发现学的那些东西用不上，真正需要的技能反而没学到。  这是企业培训的常态。*",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "培训"],
    "category": "洞察",
    "articleId": "disrupted-ai入职培训的定制化可能"
  },

  {
    "id": "course-ai帮你写jd-命中率更高了吗",
    "title": "AI帮你写JD，命中率更高了吗",
    "summary": "## 引言：JD决定了一场招聘的走向  在人力资源领域，流传着这样一句话：“职位描述写错了，整场招聘就输了一半。” Job Description（职位描述，简称JD）看似只是一份文档，却决定了候选人是否会点击投递、企业对人才的吸引力有多大",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-ai帮你写jd-命中率更高了吗"
  },

  {
    "id": "course-用ai做雇主品牌传播-让人才主动找上门",
    "title": "用AI做雇主品牌传播：让人才主动找上门",
    "summary": "## 引言  在人才争夺战日益白热化的今天，雇主品牌已从“加分项”变成“必选项”。领英调研数据显示，75%的候选人会在了解公司雇主品牌后再决定是否投递简历，而品牌优秀的企业招聘成本可降低50%，员工留存率提升30%以上。然而，传统雇主品牌建",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-用ai做雇主品牌传播-让人才主动找上门"
  },

  {
    "id": "course-招聘流程ai监控与优化",
    "title": "招聘流程AI监控与优化",
    "summary": "在数字化转型的浪潮中，企业招聘正在经历前所未有的变革。传统的人工筛选简历、电话沟通协调、线下面试安排等环节不仅耗时费力，还容易因人为因素导致标准不一、效率低下等问题。如今，人工智能技术正在深度嵌入招聘流程的每一个关键节点，从简历筛选到面试评",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "招聘"],
    "category": "洞察",
    "articleId": "disrupted-招聘流程ai监控与优化"
  },

  {
    "id": "course-ai面试中的bias问题-挑战-案例与应对策略",
    "title": "AI面试中的Bias问题：挑战、案例与应对策略",
    "summary": "## 引言  随着人工智能技术在招聘领域的广泛应用，AI面试已成为众多企业筛选候选人的重要工具。从简历筛选到视频面试评估，AI系统正以前所未有的速度介入人才招聘的核心流程。然而，当算法开始决定谁获得面试机会、谁被直接淘汰时，一个根本性问题浮",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "招聘"],
    "category": "洞察",
    "articleId": "disrupted-ai面试中的bias问题-挑战-案例与应对策略"
  },

  {
    "id": "course-用ai做薪酬谈判支持-求职者的高效助力工具",
    "title": "用AI做薪酬谈判支持：求职者的高效助力工具",
    "summary": "## 引言  薪酬谈判是求职过程中最关键的环节之一，却也是许多求职者最感压力的一步。如何在维护良好关系的前提下争取到理想的薪资待遇，往往让人举棋不定。随着人工智能技术的快速发展，AI正在悄然改变这一领域的游戏规则。本文将探讨如何借助AI工具",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-用ai做薪酬谈判支持-求职者的高效助力工具"
  },

  {
    "id": "course-候选人体验-ai的个性化关怀",
    "title": "候选人体验：AI的个性化关怀",
    "summary": "**摘要：** 在数字化转型的浪潮中，人工智能正在深刻重塑招聘行业的格局。本文聚焦于AI如何为候选人提供个性化关怀，深入探讨智能匹配、沟通自动化、体验优化等维度，揭示AI技术在提升候选人体验方面的创新实践与未来趋势。2026年的今天，AI已",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-候选人体验-ai的个性化关怀"
  },

  {
    "id": "course-ai背景调查靠谱吗",
    "title": "AI背景调查靠谱吗",
    "summary": "你有没有这种感觉：现在的AI越来越厉害了，查学历、查工作经历、查法院记录、查社交媒体——好像一个人的底细，AI分分钟就能扒得干干净净。  很多企业在招人时，开始用AI做背景调查。HR只需要把候选人的基本信息输入系统，几分钟就能拿到一份\\\"候选",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-ai背景调查靠谱吗"
  },

  {
    "id": "course-远程团队的ai协作新模式",
    "title": "远程团队的AI协作新模式",
    "summary": "你有没有遇到过这种情况：远程团队开会，一个人在说，另一个人在打字回复消息，剩下的十几个人全程沉默——会议结束了，什么结论都没有，下次开会还是同一批问题。  这不是Zoom的问题，也不是飞书或者钉钉的问题。这是远程协作的本质挑战：**同步沟通",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "协作"],
    "category": "洞察",
    "articleId": "disrupted-远程团队的ai协作新模式"
  },

  {
    "id": "course-用ai打破部门墙",
    "title": "用AI打破部门墙",
    "summary": "你有没有遇到过这种情况：公司推一个跨部门项目，先花了两个月开会协调各部门的时间，又花了一个月让各方理解彼此的工作语言，好不容易开始合作了，发现各自的数据口径不一致，再花两个月对齐数据——等项目终于跑起来，市场窗口已经过了。  这不是执行力的",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-用ai打破部门墙"
  },

  {
    "id": "course-跨部门项目-ai做协调人",
    "title": "跨部门项目：AI做协调人",
    "summary": "**作者：数智职场研究院** **日期：2026年4月30日**  ---  ## 背景：跨部门协作为何总是\\\"卡\\\"在协调上？  在企业中，跨部门项目从来都不缺愿景——缺的是把愿景落地的协调能力。  产品说\\\"这个需求本周必须上线\\\"，研发说\\\"底",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-跨部门项目-ai做协调人"
  },

  {
    "id": "course-团队知识库-ai让经验传承",
    "title": "团队知识库：AI让经验传承",
    "summary": "**作者：数智职场研究院** **日期：2026年5月1日**  ---  ## 背景：经验流失是组织最大的隐形损失  每个团队都有这样的隐痛：某位老员工离职，他脑子里积攒了三年的项目经验、踩过的坑、谈判的技巧，一夜之间全部带走。新人来了从",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-团队知识库-ai让经验传承"
  },

  {
    "id": "course-用ai做任务分配和优先级",
    "title": "用AI做任务分配和优先级",
    "summary": "在团队协作中，任务分配不合理、优先级混乱是导致效率低下的常见原因。AI技术的引入，正在彻底改变这一局面。  ## 智能任务分配的核心逻辑  AI系统能够基于多维度数据做出分配决策：团队成员的技术栈与经验、项目历史完成质量、当前工作负载量、以",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-用ai做任务分配和优先级"
  },

  {
    "id": "course-ai会议纪要之后的协作变化",
    "title": "AI会议纪要之后的协作变化",
    "summary": "AI会议纪要工具的普及，正在深刻改变团队协作的方式。传统会议结束后，信息往往停留在参会者的记忆中，难以高效传递。而AI生成的会议纪要让所有人都能快速获取一致的信息，这直接提升了协作的起点。  ## 信息透明度的提升  AI会议纪要最大的变化",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "会议", "协作"],
    "category": "洞察",
    "articleId": "disrupted-ai会议纪要之后的协作变化"
  },

  {
    "id": "course-团队沟通-ai分析情绪",
    "title": "团队沟通：AI分析情绪",
    "summary": "在现代团队协作中，沟通不仅仅是信息的传递，更是情感的交流。AI情绪分析技术正在革新我们理解和管理团队沟通的方式。  ## AI如何分析团队沟通中的情绪  AI情绪分析主要通过以下几种方式工作：  - **文本分析**：识别文字中的情感倾向，",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "协作"],
    "category": "洞察",
    "articleId": "disrupted-团队沟通-ai分析情绪"
  },

  {
    "id": "course-晨会走过场-是谁的损失",
    "title": "晨会走过场，是谁的损失？",
    "summary": "每天早上九点，会议室里坐满了人。投影仪亮着，PPT翻到第N页，有人打着哈欠，有人看着手机，有人机械地点头。十五分钟后，晨会结束。所有人站起来，走出会议室该干嘛干嘛。  这场面熟悉吗？熟悉。这就正常吗？正常。但这划算吗？  我在企业里问了上百",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-晨会走过场-是谁的损失"
  },

  {
    "id": "course-用ai发现团队中的隐形工作量",
    "title": "用AI发现团队中的隐形工作量",
    "summary": "在团队管理中，有一类工作始终难以被看见——它不体现在任务列表里，不记录在工时系统中，却真实消耗着成员的精力与时间。心理学家将这种现象称为\\\"隐形工作负荷\\\"。AI技术的介入，为揭示这一盲区提供了可能。  ## 什么是隐形工作量  它包括：临时性",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-用ai发现团队中的隐形工作量"
  },

  {
    "id": "course-ai驱动的异步协作-打破时区壁垒-重塑团队效率",
    "title": "AI驱动的异步协作：打破时区壁垒，重塑团队效率",
    "summary": "全球化与远程办公的普及让异步协作成为越来越多团队的标配。然而，跨时区、跨文化的协作往往伴随着沟通延迟、信息断层和协作效率低下等问题。AI技术的介入，正在为异步协作注入全新的动力，让团队在时间与空间的双重约束下依然保持高效运转。  ## 异步",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "协作"],
    "category": "洞察",
    "articleId": "disrupted-ai驱动的异步协作-打破时区壁垒-重塑团队效率"
  },

  {
    "id": "course-虚拟助理入驻团队-ai时代的协作新范式",
    "title": "虚拟助理入驻团队：AI时代的协作新范式",
    "summary": "当AI不再只是工具，而是以\\\"同事\\\"身份加入协作网络，团队的工作模式正在被重新定义。麦肯锡在2025年的研究报告中提出\\\"超级代理\\\"（Superagency）概念——将AI能力赋予每一位员工，让他们拥有跨越边界的执行与协调能力。虚拟助理，正是这",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "协作"],
    "category": "洞察",
    "articleId": "disrupted-虚拟助理入驻团队-ai时代的协作新范式"
  },

  {
    "id": "course-ai时代的团队仪式感-让协作重新变得有温度",
    "title": "AI时代的团队仪式感：让协作重新变得有温度",
    "summary": "当晨会变成一条飞书消息，当项目庆功变成表情包刷屏，当年度回顾变成AI生成的数字报告——我们完成了一场效率革命，却也悄然失去了一些东西。  那些让团队成员觉得自己\\\"属于这里\\\"的时刻，那些让大家暂时放下KPI、单纯因为彼此在场而感到安心的瞬间，",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "协作"],
    "category": "洞察",
    "articleId": "disrupted-ai时代的团队仪式感-让协作重新变得有温度"
  },

  {
    "id": "course-用ai做团队健康诊断-让协作问题无所遁形",
    "title": "用AI做团队健康诊断：让协作问题无所遁形",
    "summary": "在现代企业管理中，团队健康度直接影响组织效能。传统诊断依赖主观问卷与管理者经验，往往滞后于问题爆发。人工智能技术的介入，让实时、客观、可预测的团队健康诊断成为可能。  ## 一、什么是团队健康诊断  团队健康诊断是对团队协作效率、成员关系、",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "协作"],
    "category": "洞察",
    "articleId": "disrupted-用ai做团队健康诊断-让协作问题无所遁形"
  },

  {
    "id": "course-ai重塑协作工具-从效率提升到工作方式变革",
    "title": "AI重塑协作工具：从效率提升到工作方式变革",
    "summary": "协作工具的AI升级，不仅仅是功能的叠加，而是对团队工作模式的根本性重构。当文档可以主动思考、会议能够自动摘要、任务可以智能分派，协作的本质正在发生深刻变化。  ## 智能融入日常工作流  AI赋能的协作工具正在从“工具”演变为“助手”。以文",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "协作"],
    "category": "洞察",
    "articleId": "disrupted-ai重塑协作工具-从效率提升到工作方式变革"
  },

  {
    "id": "course-ai数据洞悉-决策的新方式",
    "title": "AI数据洞悉：决策的新方式",
    "summary": "**来源：McKinsey《Where AI will create value—and where it won't》(2026-04-29)**  ---  ## 引言  麦肯锡2026年研究报告《Where AI will creat",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "战略"],
    "category": "洞察",
    "articleId": "disrupted-ai数据洞悉-决策的新方式"
  },

  {
    "id": "course-用ai做竞品分析-效率提升10倍的实战方法论",
    "title": "用AI做竞品分析：效率提升10倍的实战方法论",
    "summary": "在市场竞争日益激烈的今天，竞品分析已成为企业战略决策的核心环节。传统的竞品分析依赖人工搜集信息、反复对比数据，分析师往往需要花费数周时间才能完成一份像样的报告。而AI技术的介入，正在彻底改变这一局面——将数周的工时压缩到数小时，同时覆盖更广",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-用ai做竞品分析-效率提升10倍的实战方法论"
  },

  {
    "id": "course-ai市场预测可靠吗",
    "title": "AI市场预测可靠吗",
    "summary": "## 引言  近年来，人工智能技术飞速发展，从华尔街到硅谷，从金融机构到初创企业，AI驱动的市场预测已成为一股不可忽视的潮流。高盛、摩根士丹利等顶级投行纷纷投入数十亿美元开发AI预测系统，各类\\\"AI量化基金\\\"如雨后春笋般涌现。然而，AI市场",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-ai市场预测可靠吗"
  },

  {
    "id": "course-战略规划-ai的辅助角色",
    "title": "战略规划：AI的辅助角色",
    "summary": "**情报来源：McKinsey《Where AI will create value—and where it won't》(2026-04-29)**  ---  ## 引言  在企业战略规划领域，AI正在扮演一个越来越重要的角色——但这",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "战略"],
    "category": "洞察",
    "articleId": "disrupted-战略规划-ai的辅助角色"
  },

  {
    "id": "course-用ai识别商业机会",
    "title": "用AI识别商业机会",
    "summary": "在信息爆炸的时代，商业机会往往藏匿于海量数据的缝隙之中。传统的企业决策者依靠经验、直觉和有限的市场调研来识别机会，但这种方法在面对快速变化的市场环境时显得越来越吃力。人工智能技术的崛起，正在彻底改变这一局面。通过强大的数据处理能力和深度洞察",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-用ai识别商业机会"
  },

  {
    "id": "course-ai驱动的敏捷决策",
    "title": "AI驱动的敏捷决策",
    "summary": "在当今快速变化的商业环境中，企业决策的速度与质量正在成为决定生死存亡的关键变量。传统依赖管理层经验直觉、层层汇报审批的决策模式，正面临前所未有的挑战。人工智能技术的成熟，正在从根本上重塑企业决策的底层逻辑——从“深思熟虑”到“快速响应”，从",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "战略"],
    "category": "洞察",
    "articleId": "disrupted-ai驱动的敏捷决策"
  },

  {
    "id": "course-战略会议-ai的新角色",
    "title": "战略会议：AI的新角色",
    "summary": "**情报来源：McKinsey《What it takes to build genius at scale》(2026-04-29)**  ---  ## 引言  企业战略会议正经历一场深刻变革。传统上，战略会议是高管团队闭门讨论、基于有",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "会议", "战略"],
    "category": "洞察",
    "articleId": "disrupted-战略会议-ai的新角色"
  },

  {
    "id": "course-用ai做客户反馈分析-企业洞察力的智能化升级",
    "title": "用AI做客户反馈分析：企业洞察力的智能化升级",
    "summary": "## 引言  在数字化时代，客户反馈是企业优化产品和服务的重要依据。传统人工分析效率低下，难以应对海量数据带来的挑战。人工智能技术为企业提供了全新的解决方案——通过AI进行客户反馈分析，能够快速、准确地从大量数据中提取有价值的信息，帮助企业",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-用ai做客户反馈分析-企业洞察力的智能化升级"
  },

  {
    "id": "course-ai危机预警系统-企业智能风险管理的核心基础设施",
    "title": "AI危机预警系统：企业智能风险管理的核心基础设施",
    "summary": "在当今快速变化的商业环境中，企业面临的危机类型日益复杂多样。从供应链中断、金融市场波动，到舆情危机与合规风险，传统的事后响应模式已难以满足企业稳健运营的需求。AI危机预警系统作为人工智能技术在企业风险管理领域的重要应用，正在成为组织构建主动",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-ai危机预警系统-企业智能风险管理的核心基础设施"
  },

  {
    "id": "course-ai驱动的创新工作坊-重塑企业创意生成与战略落地流程",
    "title": "AI驱动的创新工作坊：重塑企业创意生成与战略落地流程",
    "summary": "在当今快速变化的商业环境中，创新能力已成为企业核心竞争力的关键要素。然而，许多企业在开展创新工作坊时面临一个共同的困境：传统模式下的创意生成效率低下，跨部门协作存在障碍，且难以将零散的想法快速转化为可执行的战略方案。近年来，人工智能技术的成",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "战略"],
    "category": "洞察",
    "articleId": "disrupted-ai驱动的创新工作坊-重塑企业创意生成与战略落地流程"
  },

  {
    "id": "course-新业务靠直觉决策-ai反而更靠谱",
    "title": "新业务靠直觉决策，AI反而更靠谱？",
    "summary": "你上次拍板做新业务，是靠什么？  老板一句\\\"我觉得行\\\"，财务一份\\\"看起来很美\\\"的PPT，团队一腔热血——然后呢？  然后就没有然后了。  **一个新业务能不能做，大多数公司靠的是直觉，而不是数据。**  这不是个例。这是管理学上著名的\\\"承诺",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "战略"],
    "category": "洞察",
    "articleId": "disrupted-新业务靠直觉决策-ai反而更靠谱"
  },

  {
    "id": "course-花了大价钱上ai-怎么知道亏没亏",
    "title": "花了大价钱上AI，怎么知道亏没亏？",
    "summary": "你是不是也这样：年初豪掷几百万上了AI系统，年末汇报时却拿不出数据证明它值回票价。  老板问ROI，你只能支支吾吾说\\\"效率好像提高了\\\"。  这不是个别现象。**大多数企业知道怎么买AI，却不知道怎么做投资回报分析。**  ---  ## 核",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-花了大价钱上ai-怎么知道亏没亏"
  },

  {
    "id": "course-你的战略执行监控-其实一直在骗你",
    "title": "你的战略执行监控，其实一直在骗你？",
    "summary": "开完季度会，你信心满满。PPT上的进度条一片绿，OKR完成率87%，重点项目全部\\\"正常推进\\\"。  然后一年结束，全年目标落空。  哪里出了问题？  不是你的战略错了。是你看到的监控数据，从根上就是假的。  **核心观点：AI时代的战略执行监",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "战略"],
    "category": "洞察",
    "articleId": "disrupted-你的战略执行监控-其实一直在骗你"
  },

  {
    "id": "course-你的增长机会-ai比你更早发现",
    "title": "你的增长机会，AI比你更早发现",
    "summary": "你有没有这种感觉：  看着报表，数据都在，但就是不知道下一个增长点在哪。  团队很努力，KPI也完成了，但就是没有那种\\\"突破\\\"的感觉。  这不是你不行了。这是人的局限——我们习惯在熟悉的地方找机会，在已知的市场里打转。  但AI不一样。  ",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-你的增长机会-ai比你更早发现"
  },

  {
    "id": "course-战略复盘-你还在用五年前的方法",
    "title": "战略复盘，你还在用五年前的方法？",
    "summary": "每年做复盘，PPT改了十几版，数据填了几十页。团队累得半死，开完会该犯的错还是犯。  问题不是复盘不够勤，是复盘的方式从根上就错了。  **核心观点：AI时代的战略复盘，不是让复盘更高效，而是让复盘真正看见因果。**  ---  ## 01",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "战略"],
    "category": "洞察",
    "articleId": "disrupted-战略复盘-你还在用五年前的方法"
  },

  {
    "id": "course-ai培训-个性化时代来了",
    "title": "AI培训：个性化时代来了",
    "summary": "传统的员工培训往往是“一刀切”——几十人、上百人坐在同一间教室里，听同样的课程，做同样的练习。然而，这种模式正在被AI技术彻底颠覆。**AI驱动的个性化培训**正成为企业人才培养的新标配。  ## 从“要我学”到“我要学”：AI重新定义培训",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "培训"],
    "category": "洞察",
    "articleId": "disrupted-ai培训-个性化时代来了"
  },

  {
    "id": "course-用ai做技能差距分析",
    "title": "用AI做技能差距分析",
    "summary": "在人力资源管理和组织发展的工作中，技能差距分析是识别团队能力短板、制定培训计划的关键环节。传统方式依赖问卷、访谈和人工评估，不仅耗时耗力，还容易因主观判断导致结果偏差。随着人工智能技术的成熟，越来越多的企业开始探索用AI来做技能差距分析，实",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-用ai做技能差距分析"
  },

  {
    "id": "course-ai时代需要什么新技能",
    "title": "AI时代需要什么新技能",
    "summary": "随着人工智能技术在工作场所的快速渗透，职场技能需求正在经历结构性重塑。麦肯锡在2026年4月发布的报告《人类与AI劳动力的崛起》指出，企业若继续依赖传统技能培养模式，将面临严重的人岗错配风险。这一背景下，理解AI时代究竟需要哪些新技能，已成",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-ai时代需要什么新技能"
  },

  {
    "id": "course-用ai做学习路径规划-让每位员工的成长都有迹可循",
    "title": "用AI做学习路径规划：让每位员工的成长都有迹可循",
    "summary": "传统的企业培训往往是“课程堆砌”——员工被安排参加一堆看似相关却缺乏逻辑串联的培训项目，学完后依然不清楚自己到底需要补什么、向什么方向发展。学习路径的设计要么依赖管理者的个人经验，要么干脆交给员工自己摸索。这种粗放式的学习管理，正在被AI驱",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "培训"],
    "category": "洞察",
    "articleId": "disrupted-用ai做学习路径规划-让每位员工的成长都有迹可循"
  },

  {
    "id": "course-导师制被ai重新定义",
    "title": "导师制被AI重新定义",
    "summary": "传统企业中，导师制往往依赖资深员工的时间与经验，存在匹配效率低、覆盖范围有限等问题。麦肯锡2026年发布的研究报告指出，AI正在从根本上重构导师制的运作模式——不是替代人类导师，而是将其升级为规模化、个性化的学习加速器。  ## AI导师：",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-导师制被ai重新定义"
  },

  {
    "id": "course-培训砸了几十万-员工还是不会-ai让学习效果评估从-玄学-变-科学",
    "title": "培训砸了几十万，员工还是不会？AI让学习效果评估从\"玄学\"变\"科学\"",
    "summary": "每到年底做培训总结时，HR和林林总总的业务部门负责人都会面对同一个灵魂拷问：**花了这么多钱和时间，员工到底学会了什么？**  传统的做法往往是填问卷、打评分、测考试，但这些方法的最大问题不是不够精确，而是**太滞后、太主观、太碎片**。等",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "培训"],
    "category": "洞察",
    "articleId": "disrupted-培训砸了几十万-员工还是不会-ai让学习效果评估从-玄学-变-科学"
  },

  {
    "id": "course-培训预算年年涨-员工却抱怨-学不到东西-是时候用ai重新定义岗位培训了",
    "title": "培训预算年年涨，员工却抱怨\"学不到东西\"？是时候用AI重新定义岗位培训了",
    "summary": "每年HR部门都在培训上砸重金——外聘讲师、购买课程、组织工作坊……可年底调研时，员工依然摇头：\\\"这些内容和我的工作没什么关系。\\\"  这不是个例。麦肯锡2024年的调研显示，76%的知识工作者认为企业培训\\\"不够针对性\\\"，而制造业、医疗、金融等",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "培训"],
    "category": "洞察",
    "articleId": "disrupted-培训预算年年涨-员工却抱怨-学不到东西-是时候用ai重新定义岗位培训了"
  },

  {
    "id": "course-老师傅的经验-ai比你先学会",
    "title": "老师傅的经验，AI比你先学会",
    "summary": "很多企业最值钱的东西，从来不在系统里，而是在老师的脑子里。  销售冠军谈客户的\\\"感觉\\\"，老工程师调试设备的\\\"手感\\\"，资深HR处理劳动纠纷的\\\"分寸\\\"——这些东西，你没法从网上搜到，也没法从教科书里学到。它们是企业真正的护城河，也是最脆弱的资产",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-老师傅的经验-ai比你先学会"
  },

  {
    "id": "course-还在让员工-看着学-ai实战演练让能力真正长在身上",
    "title": "还在让员工\\\"看着学\\\"？AI实战演练让能力真正长在身上",
    "summary": "培训做过无数遍，考核分数也不低，可一上真实战场就露怯——这是让无数HR和管理者头疼的顽疾。  某制造业客户的培训负责人曾向我倒苦水：他们花大价钱给销售团队做了为期两周的产品知识培训，闭卷考试平均分90以上。可三个月后，老客户反馈说\\\\\"你们的",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-还在让员工-看着学-ai实战演练让能力真正长在身上"
  },

  {
    "id": "course-培训砸了几十万-怎么知道有没有用-ai让效果追踪不再靠猜",
    "title": "培训砸了几十万，怎么知道有没有用？AI让效果追踪不再靠猜",
    "summary": "做过培训的人都有这样的困惑：钱花了，课上了，学员也反馈\\\"挺好的\\\"——可回到岗位上，该不会的还是不会，绩效该提不上去还是提不上去。培训到底有没有用？没人说得清。  传统的方式要么靠直觉，要么靠事后填张表。这些方法早就跟不上节奏了。  AI正在",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "培训"],
    "category": "洞察",
    "articleId": "disrupted-培训砸了几十万-怎么知道有没有用-ai让效果追踪不再靠猜"
  },

  {
    "id": "course-还在用-轮岗-培养管理者-ai模拟管理场景才是新解法",
    "title": "还在用“轮岗”培养管理者？AI模拟管理场景才是新解法",
    "summary": "培养一个合格的管理者有多难？  传统路径是：送去上课，学点理论，然后“在工作中成长”。可现实是，真正的管理能力——如何处理团队冲突、如何做艰难的绩效面谈、如何在资源有限时做决策——这些靠听课根本学不会，只能在真实情境中一点点磨出来。  问题",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-还在用-轮岗-培养管理者-ai模拟管理场景才是新解法"
  },

  {
    "id": "course-ai知识库的建设与运营-企业智能化转型的基础设施",
    "title": "AI知识库的建设与运营：企业智能化转型的基础设施",
    "summary": "最近和几位HR负责人聊天，大家不约而同提到一个痛点：公司积累了大量培训资料、业务文档、经验案例，但需要用的时候总是找不到，找到了也不敢直接用，因为不知道是不是最新版本。  这不是个例。大多数企业在知识管理上都经历过三个阶段：**\\\"存起来就好",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-ai知识库的建设与运营-企业智能化转型的基础设施"
  },

  {
    "id": "course-游戏化学习-ai的新玩法",
    "title": "游戏化学习：AI的新玩法",
    "summary": "你上一次认真学习新技能是什么时候？翻开书看了两页，刷了十分钟手机，然后……就没有然后了。  这不是你的问题。传统学习的体验实在太枯燥了——无非是看书、听课、做题三件套，靠意志力硬撑。但你有没有想过，如果学习能像打游戏一样让人上瘾呢？  这两",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "培训"],
    "category": "洞察",
    "articleId": "disrupted-游戏化学习-ai的新玩法"
  },

  {
    "id": "course-持续学习-ai的推动作用",
    "title": "持续学习：AI的推动作用",
    "summary": "在这个信息爆炸的时代，知识更新的速度远超以往任何时期。一个几年前还被认为是前沿的技术，今天可能已经成为入门基础。这种环境下，\\\"持续学习\\\"不再是一种选择，而是每个人必须面对的生存技能。而在这场学习革命中，人工智能正在扮演一个前所未有的角色——",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "培训"],
    "category": "洞察",
    "articleId": "disrupted-持续学习-ai的推动作用"
  },

  {
    "id": "course-ai时代的企业文化重塑-不是引入工具-而是重写规则",
    "title": "AI时代的企业文化重塑：不是引入工具，而是重写规则",
    "summary": "你有没有这种感觉：公司上了AI系统，员工却依然用老办法干活；花大价钱买了智能工具，大家却觉得是负担；试点项目明明很成功，推广时却处处碰壁。  这不是技术问题，而是文化问题。  麦肯锡最新报告指出了一个让很多企业管理者头疼的现象：AI试点遍地",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "文化"],
    "category": "洞察",
    "articleId": "disrupted-ai时代的企业文化重塑-不是引入工具-而是重写规则"
  },

  {
    "id": "course-用ai做文化感知分析-让组织氛围从-凭感觉-变成-看得见",
    "title": "用AI做文化感知分析：让组织氛围从\"凭感觉\"变成\"看得见\"",
    "summary": "你有没有遇到过这种情况：团队士气明明在下降，但绩效考核却一片祥和；跨部门协作越来越难，但每次调研都显示\\\"沟通良好\\\"；员工嘴上说满意，但离职率却悄悄攀升。  传统的文化感知靠的是问卷调查、年度调研、一对一访谈。但这些方式有三个致命缺陷——**",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "文化"],
    "category": "洞察",
    "articleId": "disrupted-用ai做文化感知分析-让组织氛围从-凭感觉-变成-看得见"
  },

  {
    "id": "course-员工关怀-ai新方式-从标准化服务到个性化温暖的跨越",
    "title": "员工关怀：AI新方式——从标准化服务到个性化温暖的跨越",
    "summary": "你有没有这种感觉：公司的员工关怀永远停留在过节发礼品、年度体检、团建聚餐这\\\"老三样\\\"；HR每天忙得团团转，员工却依然觉得缺乏归属感；明明福利预算年年涨，满意度却不见提升。  问题不在于关怀做得不够多，而在于做得太\\\"平均\\\"。  传统员工关怀是",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-员工关怀-ai新方式-从标准化服务到个性化温暖的跨越"
  },

  {
    "id": "course-用ai做员工满意度调研-让真实的声音不再被淹没",
    "title": "用AI做员工满意度调研：让真实的声音不再被淹没",
    "summary": "传统的员工满意度调研，总是逃不出那几个熟悉的场景：年底发一份问卷，回收率勉强过半，员工在\\\"满意\\\"到\\\"非常满意\\\"之间打勾，HR整理数据写成报告，管理层看两眼就束之高阁。下一年，周而复始。  这不是调研，这是一场\\\"共谋的表演\\\"。  员工不是傻子",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-用ai做员工满意度调研-让真实的声音不再被淹没"
  },

  {
    "id": "course-你的会议-正在被ai-偷听",
    "title": "你的会议，正在被AI\"偷听\"？",
    "summary": "你有没有过这种感觉？  当你知道会议室里有一个AI正在记录一切的时候，你说话会变得格外小心。那些在脑子里一闪而过的吐槽的话，那些随口而出对同事的抱怨，那些只在内部群里说的真话——你突然不敢说了。  因为你知道，AI不仅在听，还在记。  今天",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "会议"],
    "category": "洞察",
    "articleId": "disrupted-你的会议-正在被ai-偷听"
  },

  {
    "id": "course-内部沟通-ai新模式",
    "title": "内部沟通：AI新模式",
    "summary": "你是否有过这样的体验：公司发布了一条重要通知，你是在三天后才从茶水间的闲聊中得知的？部门之间隔着一堵看不见的墙，明明可以协作的项目，因为信息不对称而各自为战？领导在会上传达的精神，经过层层转述后，变成了面目全非的\\\"二次创作\\\"？  这些问题，",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "协作"],
    "category": "洞察",
    "articleId": "disrupted-内部沟通-ai新模式"
  },

  {
    "id": "course-价值观传播-ai的方式",
    "title": "价值观传播：AI的方式",
    "summary": "你有没有遇到过这种情况：公司的价值观写在墙上、印在手册里、挂在年会上，但员工在日常工作中感受到的，却是另一套逻辑——口号是\\\"客户第一\\\"，但内部考核只看短期业绩；宣导\\\"创新包容\\\"，但实际奖励的是\\\"听话出活\\\"。  这不是个别企业的特例，而是一个",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-价值观传播-ai的方式"
  },

  {
    "id": "course-用ai做文化一致性检查",
    "title": "用AI做文化一致性检查",
    "summary": "你有没有见过这种场景：公司的价值观写得漂漂亮亮——\\\"诚信正直\\\"、\\\"客户至上\\\"、\\\"追求卓越\\\"，但走进日常业务，扑面而来的却是另一番景象——为了签单可以隐瞒产品缺陷，内部协作靠的是\\\"谁关系好谁先处理\\\"，汇报材料永远只说领导想听的话。  这不是某",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "文化"],
    "category": "洞察",
    "articleId": "disrupted-用ai做文化一致性检查"
  },

  {
    "id": "course-ai时代的组织认同感-当我们成为-被算法定义的人",
    "title": "AI时代的组织认同感：当我们成为\"被算法定义的人\"",
    "summary": "你有多久没有认真回答过\\\"我是谁\\\"这个问题了？  不是那个印在工牌上的职位名称，也不是企业微信签名栏里的公司title。而是真正想清楚：你在这家公司工作，因为什么而感到骄傲？你和这个组织之间，除了每个月准时到账的工资，还有什么更深的联结？  ",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-ai时代的组织认同感-当我们成为-被算法定义的人"
  },

  {
    "id": "course-用ai发现文化问题-让组织隐患从-视而不见-到-提前预警",
    "title": "用AI发现文化问题：让组织隐患从“视而不见”到“提前预警”",
    "summary": "你有没有遇到过这种情况：团队明明运转正常，但某个项目突然失败时，你才发现协作链条早就出了问题；企业文化手册写得漂漂亮亮，但员工离职时的面谈却揭示出完全不同的故事；并购前做足了文化评估，并购后却发现两家公司的价值观像是来自不同星球。  这些情",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "文化"],
    "category": "洞察",
    "articleId": "disrupted-用ai发现文化问题-让组织隐患从-视而不见-到-提前预警"
  },

  {
    "id": "course-文化落地-ai帮忙监督",
    "title": "文化落地：AI帮忙监督",
    "summary": "你有没有遇到过这种情况：公司的价值观海报贴满了走廊，但员工在走廊里打电话的方式，和海报上的价值观完全不符；领导在台上讲\\\"客户第一\\\"，但客户投诉处理流程却需要五层审批；年会强调\\\"创新突破\\\"，但真正提出创新想法的人却在季度评审时被扣上了\\\"不务正",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "文化"],
    "category": "洞察",
    "articleId": "disrupted-文化落地-ai帮忙监督"
  },

  {
    "id": "course-ai做年度报告-新模式",
    "title": "AI做年度报告：新模式",
    "summary": "又到年底，你有没有经历过这样的崩溃时刻——  数据散落在七八个系统里，光是汇总就要三天；好不容易拼出一份报告，老板说\\\"没有洞察，只有堆数字\\\"；改了三版之后发现，最初的数据口径就错了，一切重来。  年度报告，这件每年都要经历一次的事，正在被A",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-ai做年度报告-新模式"
  },

  {
    "id": "course-做预算-还要花一整月",
    "title": "做预算，还要花一整月？",
    "summary": "**年底做预算，你是不是也这样：财务扔模板，销售填数字，HR估人头，最后老板拍脑袋？一圈下来，少则三周，多则一个月。等预算定下来，市场早就变了。**  这不是哪家公司的问题。这是传统预算编制的结构性缺陷。  **用AI做预算编制，核心改变只",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-做预算-还要花一整月"
  },

  {
    "id": "course-你的考勤机-正在变成一台-谎话制造机",
    "title": "你的考勤机，正在变成一台\"谎话制造机\"。",
    "summary": "每个月，总有那么几个员工对着打卡机叹气。迟到了3分钟，系统记成旷工半天。请假流程跑三天，最后发现HR漏看了邮件。加班记录全靠手动统计，财务发工资时才发现对不上。  这不是个别现象。这是考勤管理在互联网时代的结构性失效。  AI正在重写这套游",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-你的考勤机-正在变成一台-谎话制造机"
  },

  {
    "id": "course-法务合规-ai来帮忙",
    "title": "法务合规：AI来帮忙",
    "summary": "## 你的法务部门，为什么总在加班？  你有没有发现，公司的法务部门永远是加班最严重的团队之一？  合同堆成山，法律研究做不完，合规检查一个接一个。律师们的时间，80%花在了文档审查、数据检索、格式核对这些重复性工作上。真正考验专业能力的策",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-法务合规-ai来帮忙"
  },

  {
    "id": "course-ai打分比人工更公正-别闹了",
    "title": "AI打分比人工更公正？别闹了",
    "summary": "> “如果你现在还在迷信AI打分，那韭菜的就是你。”  ## 01 痛的引入：一个正在发生的撕裂  最近一家互联网大厂出了个事。年终绩效评定，公司全面启用AI评估系统，给每个员工打分。系统运行三个月后，研发团队整体评分普遍低于销售团队。技术",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-ai打分比人工更公正-别闹了"
  },

  {
    "id": "course-ai预测员工离职风险的深度思考",
    "title": "AI预测员工离职风险的深度思考",
    "summary": "## 反直觉的核心洞察  你是否想过这样一个问题：**为什么等到员工递交辞职信的那一刻，你才发现自己被“突袭”了？**  这不是一个反问。这是一个事实。  大多数企业的HR管理者都经历过这样的场景：一位表现稳定的员工，突然在某个周一上午走进",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-ai预测员工离职风险的深度思考"
  },

  {
    "id": "course-年度绩效评价-为什么越来越像个笑话",
    "title": "年度绩效评价，为什么越来越像个笑话？",
    "summary": "你今年绩效被打C了。在此之前，你完全不知道。  这不是个案。我问过上百位职场人：你在年度绩效评定之前，知道自己会被评為C吗？90%的人回答不知道，还有一部分人说\\\"隐约觉得不对，但不确定\\\"。  这就对了。年度绩效评价，本质上是一场延迟了12个",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "绩效"],
    "category": "洞察",
    "articleId": "disrupted-年度绩效评价-为什么越来越像个笑话"
  },

  {
    "id": "course-情报解读-ai时代-人类员工需要什么新技能",
    "title": "【情报解读】AI时代：人类员工需要什么新技能",
    "summary": "## 背景  McKinsey最新研究显示，AI目前已能承担美国超过一半的工作时长。这一数据来自麦肯锡组织与人才绩效团队2026年4月30日发布的报告《The rise of the human–AI workforce》。研究的核心结论是",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "stable-情报解读-ai时代-人类员工需要什么新技能"
  },

  {
    "id": "course-情报解读-ai规模化落地为什么缺的不是技术而是组织学习",
    "title": "【情报解读】AI规模化落地为什么缺的不是技术而是组织学习",
    "summary": "**情报来源**: McKinsey \\\"Rewiring for AI: From ambition to advantage\\\" (2026-05-07) **解读日期**: 2026-05-08  ---  ## 背景  麦肯锡最新报告指",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "培训"],
    "category": "洞察",
    "articleId": "stable-情报解读-ai规模化落地为什么缺的不是技术而是组织学习"
  },

  {
    "id": "course-情报解读-ai重塑欧洲职场-技能转型比岗位替代更紧迫",
    "title": "【情报解读】AI重塑欧洲职场：技能转型比岗位替代更紧迫",
    "summary": "**来源**: McKinsey Featured Insights **日期**: 2026年5月12日 **原始标题**: Agents, robots, and us: How AI reshapes work and skills ",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "stable-情报解读-ai重塑欧洲职场-技能转型比岗位替代更紧迫"
  },

  {
    "id": "course-情报解读-mckinsey-为什么说-超级代理-将重塑工作场所",
    "title": "【情报解读】McKinsey：为什么说\"超级代理\"将重塑工作场所",
    "summary": "## 背景  McKinsey发布的最新报告显示，全球绝大多数企业都在投资AI，但仅有**1%的企业认为自己的AI应用达到成熟度**。更有趣的发现是：员工对AI的接受度和准备度实际上**高于管理层**——最大的障碍不是员工不行，而是领导层没",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "stable-情报解读-mckinsey-为什么说-超级代理-将重塑工作场所"
  },

  {
    "id": "course-情报解读-openai与pwc合作-cfo办公室的ai变革",
    "title": "【情报解读】OpenAI与PwC合作：CFO办公室的AI变革",
    "summary": "## 背景  OpenAI与普华永道于2026年5月4日宣布战略合作，共同开发面向CFO办公室的AI代理解决方案。这一合作标志着企业AI应用从边缘业务向核心管理职能的深度渗透。  ## 核心发现  ### 1. AI代理重塑财务工作流 传统",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "stable-情报解读-openai与pwc合作-cfo办公室的ai变革"
  },

  {
    "id": "course-",
    "title": "---",
    "summary": "source: intelligence date: 2026-05-18 ---  【情报解读】从AI入局到AI优势：构建企业竞争护城河  **背景：**  McKinsey最新发布的文章《From AI table stakes to ",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "stable-"
  },

  {
    "id": "course-情报解读-企业ai规模化落地的三大支柱-信任-治理与工作流设计",
    "title": "【情报解读】企业AI规模化落地的三大支柱：信任、治理与工作流设计",
    "summary": "**情报来源**: OpenAI \\\"How enterprises are scaling AI\\\" (2026-05-11) **链接**: https://openai.com/business/guides-and-resources/",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "stable-情报解读-企业ai规模化落地的三大支柱-信任-治理与工作流设计"
  },

  {
    "id": "course-情报解读-前沿企业如何靠ai建立持久竞争优势",
    "title": "【情报解读】前沿企业如何靠AI建立持久竞争优势",
    "summary": "**情报来源**：OpenAI \\\"How frontier enterprises are building an AI advantage\\\" (2026-05-06)  ## 背景  OpenAI最新发布的B2B Signals研究报告，",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "stable-情报解读-前沿企业如何靠ai建立持久竞争优势"
  },

  {
    "id": "course-情报解读-欧洲ai投资悖论-钱没少花-回报去哪了",
    "title": "【情报解读】欧洲AI投资悖论：钱没少花，回报去哪了？",
    "summary": "**情报来源**: McKinsey QuantumBlack, 2026-05-04 **原题**: The AI paradox in Europe's consumer industries: More spending, elusi",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "stable-情报解读-欧洲ai投资悖论-钱没少花-回报去哪了"
  },

  {
    "id": "course-情报解读-麦肯锡警告-ceo的ai转型窗口期正在关闭",
    "title": "【情报解读】麦肯锡警告：CEO的AI转型窗口期正在关闭",
    "summary": "**情报来源**: McKinsey \\\"The AI assembly line: Strategic imperatives for CEOs\\\" (2026-05-13) **链接**: https://www.mckinsey.com/",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理"],
    "category": "洞察",
    "articleId": "stable-情报解读-麦肯锡警告-ceo的ai转型窗口期正在关闭"
  },

  {
    "id": "course-绩效申诉让ai来裁-公平吗",
    "title": "绩效申诉让AI来裁，公平吗？",
    "summary": "你有没有遇到过这种情况：年终绩效被打了个C，找主管申诉，主管说“这是系统评的，我也没法改”。你心里一万个问号——一台服务器，凭什么决定我的命运？  这事儿正在变成普遍问题。越来越多的公司把绩效评估AI化了。从，目标设定、打分排名到晋升决策，",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["AI", "组织管理", "绩效"],
    "category": "洞察",
    "articleId": "disrupted-绩效申诉让ai来裁-公平吗"
  },

  {
    "id": "course-ai-monitoring-trust-crisis",
    "title": "AI监控与信任危机",
    "summary": "AI监控让员工行为收缩、表演性工作增加、最优秀的人最先走。",
    "modules": 1,
    "audience": "管理者、HR、团队负责人",
    "tags": ["AI", "组织管理", "信任"],
    "category": "洞察",
    "articleId": "disrupted-ai-monitoring-trust-crisis"
  },

  {
    "id": "course-ai-process-rigidity-resilience",
    "title": "AI流程与组织弹性",
    "summary": "AI流程自动化提升了效率，但代价是组织的弹性。",
    "modules": 1,
    "audience": "管理者、流程负责人、运营总监",
    "tags": ["AI", "组织管理", "流程"],
    "category": "洞察",
    "articleId": "disrupted-ai-process-rigidity-resilience"
  },

  {
    "id": "course-ai-data-compliance-legal-risk",
    "title": "AI数据合规与法律风险",
    "summary": "AI时代的数据合规不是HR或IT的问题，是CEO签支票时手抖不抖的问题。",
    "modules": 1,
    "audience": "管理者、法务、HR",
    "tags": ["AI", "数据合规", "法律"],
    "category": "洞察",
    "articleId": "disrupted-ai-data-compliance-legal-risk"
  },

  {
    "id": "course-algorithmic-management-efficiency-humanity",
    "title": "算法管理与人性选择",
    "summary": "AI知道你要去哪里，但AI不知道你怎么了。",
    "modules": 1,
    "audience": "管理者、CEO、运营总监",
    "tags": ["AI", "组织管理", "算法管理"],
    "category": "洞察",
    "articleId": "disrupted-algorithmic-management-efficiency-humanity"
  },

  {
    "id": "course-ai-cross-department-collaboration",
    "title": "AI跨部门协作",
    "summary": "AI帮我们把协作管理得井井有条，如果没人在意协作是否真的发生了的话。",
    "modules": 1,
    "audience": "管理者、项目负责人、部门主管",
    "tags": ["AI", "跨部门协作", "组织管理"],
    "category": "洞察",
    "articleId": "disrupted-ai-cross-department-collaboration"
  },
  {
    "id": "course-resign-prediction-ethics",
    "title": "AI离职预测伦理",
    "summary": "当AI能预测员工离职，管理者面临的是一个伦理选择——知道真相不等于应该说出真相。",
    "modules": 1,
    "audience": "管理者、HRD、CEO",
    "tags": ["AI伦理", "离职预测", "人才管理"],
    "category": "洞察",
    "articleId": "disrupted-resign-prediction-ethics"
  },
  {
    "id": "course-project-failure-paradox",
    "title": "AI项目决策",
    "summary": "AI说项目会失败但你还是得做——学会区分复制型、改良型和开创型项目的AI使用规则。",
    "modules": 1,
    "audience": "管理者、项目经理、产品负责人",
    "tags": ["创新管理", "AI决策", "项目立项"],
    "category": "洞察",
    "articleId": "disrupted-project-failure-paradox"
  },
  {
    "id": "course-ai-resume-hr-disagreement",
    "title": "AI简历筛选冲突",
    "summary": "AI做一维匹配、HR做多维权衡——弥合人机分歧才能提升招聘效率。",
    "modules": 1,
    "audience": "HR、招聘经理、HRD",
    "tags": ["招聘", "AI筛选", "人机分歧"],
    "category": "洞察",
    "articleId": "disrupted-ai-resume-hr-disagreement"
  },
  {
    "id": "course-ai-decision-atrophy",
    "title": "AI决策萎缩",
    "summary": "当AI替你做了95%的决定后，你的判断力正在悄悄消失——如何对抗决策萎缩。",
    "modules": 1,
    "audience": "管理者、总监、VP",
    "tags": ["决策萎缩", "人机协同", "管理能力"],
    "category": "洞察",
    "articleId": "disrupted-ai-decision-atrophy"
  },
  {
    "id": "course-ai-slacking-detection",
    "title": "AI摆烂识别",
    "summary": "AI能发现谁在摆烂，但五分之一是误伤——数据是信号不是判决。",
    "modules": 1,
    "audience": "团队管理者、部门总监、CEO",
    "tags": ["团队管理", "暗性生产力", "AI洞察"],
    "category": "洞察",
    "articleId": "disrupted-ai-slacking-detection"
  },
  {
    "id": "course-ai-interview-human-trust",
    "title": "AI面试信任",
    "summary": "AI面试效率高，但候选人信任低——面试的本质不是筛选，是双向评估。",
    "modules": 1,
    "audience": "HR、招聘经理、HRD",
    "tags": ["招聘", "AI面试", "人机信任"],
    "category": "洞察",
    "articleId": "disrupted-ai-interview-trust"
  },
  {
    "id": "course-ai-salary-fairness",
    "title": "AI薪酬公平感",
    "summary": "AI算得再准，人在意的是被公平对待的感觉——精确不是薪酬唯一的答案。",
    "modules": 1,
    "audience": "HR、薪酬负责人、管理层",
    "tags": ["薪酬", "公平感", "AI边界"],
    "category": "洞察",
    "articleId": "disrupted-ai-salary-fairness"
  },
  {
    "id": "course-ai-okr-commitment",
    "title": "AI OKR承诺感",
    "summary": "AI写的OKR完美但不被执行——缺乏参与就没有承诺，承诺先于内容。",
    "modules": 1,
    "audience": "团队负责人、OKR推行者、OD",
    "tags": ["OKR", "目标管理", "承诺感"],
    "category": "洞察",
    "articleId": "disrupted-ai-okr-commitment"
  },
  {
    "id": "course-ai-training-paradox",
    "title": "AI培训效率悖论",
    "summary": "AI让学习变舒服了，但舒服的学习不是真正的学习——效率不是目标，学会才是。",
    "modules": 1,
    "audience": "培训经理、培训总监、学习发展负责人",
    "tags": ["培训", "学习效率", "舒适区悖论"],
    "category": "洞察",
    "articleId": "disrupted-ai-training-paradox"
  },
  {
    "id": "course-ai-personal-isolation",
    "title": "个人AI孤岛",
    "summary": "每个人的AI效率都提高了，但团队协作效率下降了——信息孤岛变成了个人AI孤岛。",
    "modules": 1,
    "audience": "团队负责人、CTO、运营总监",
    "tags": ["个人AI", "信息孤岛", "协同成本"],
    "category": "洞察",
    "articleId": "disrupted-ai-personal-isolation"
  },
  {
    "id": "course-stable-用ai发现团队中的隐形工作量",
    "title": "用AI发现团队中的隐形工作量",
    "category": "stable",
    "quiz_url": "/courses/course-stable-用ai发现团队中的隐形工作量/quiz.html",
    "handbook_url": "/courses/course-stable-用ai发现团队中的隐形工作量/handbook.html",
    "articleId": "stable-用ai发现团队中的隐形工作量",
    "summary": "隐形工作负荷的AI发现方法——让沉默的付出被看见、被承认、被合理分配",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["隐形工作量", "AI", "团队管理"]
  },
  {
    "id": "course-stable-培训预算年年涨-员工却抱怨-学不到东西-是时候用ai重新定义岗位培训了",
    "title": "培训预算年年涨，员工却抱怨'学不到东西'？是时候用AI重新定义岗位培训了",
    "category": "stable",
    "quiz_url": "/courses/course-stable-培训预算年年涨-员工却抱怨-学不到东西-是时候用ai重新定义岗位培训了/quiz.html",
    "handbook_url": "/courses/course-stable-培训预算年年涨-员工却抱怨-学不到东西-是时候用ai重新定义岗位培训了/handbook.html",
    "articleId": "stable-培训预算年年涨-员工却抱怨-学不到东西-是时候用ai重新定义岗位培训了",
    "summary": "AI诊断→动态路径→即时反馈→数据闭环。每年培训预算涨，员工却说'学不到东西'——不是钱花少了，是太'通用'了。AI让定制化培训从奢侈品变成每个HR都能落地的标配。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR",
    "tags": ["培训", "AI", "HR", "学习发展"]
  },

  {
    "id": "course-ai-organizational-silence",
    "title": "打破AI时代的组织沉默",
    "category": "stable",
    "quiz_url": "/courses/course-ai-organizational-silence/quiz.html",
    "handbook_url": "/courses/course-ai-organizational-silence/handbook.html",
    "articleId": "ai-organizational-silence",
    "summary": "AI时代组织沉默从不敢说到不配说。三个机制：答案焦虑、表达耻感、沉默传染。让团队在AI时代重新敢说真话——重新定义发言价值、带头说蠢话、把质疑AI变成被奖励的行为。",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": ["组织沉默", "AI", "团队沟通"]
  },
  {
    "id": "course-ai-office-war",
    "title": "AI办公工具选型",
    "category": "disrupted",
    "quiz_url": "/courses/course-ai-office-war/quiz.html",
    "handbook_url": "/courses/course-ai-office-war/handbook.html",
    "articleId": "ai-office-war",
    "summary": "阿里腾讯字节集体押注AI办公，本质是办公权力重新分配。选平台先看自己的痛点、小范围试点、先做数据安全体检、建立切换预案。跟不跟不是问题，怎么跟才是。",
    "modules": 1,
    "audience": "管理者、CTO、运营总监",
    "tags": ["AI办公", "组织效率", "数字化转型"]
  },
  {
    "id": "course-ai-workplace-feral",
    "title": "AI时代的情绪治理",
    "category": "created",
    "quiz_url": "/courses/course-ai-workplace-feral/quiz.html",
    "handbook_url": "/courses/course-ai-workplace-feral/handbook.html",
    "articleId": "ai-workplace-feral",
    "summary": "AI把所有事接管后，剩下的全是情绪活。组织正在流失情绪这个最贵的隐性资产。承认情绪价值、建情绪下脚口、把情绪价值纳入考核——谁经营好情绪，谁掌握AI时代的竞争力。",
    "modules": 1,
    "audience": "管理者、HR、团队负责人",
    "tags": ["职场情绪", "AI办公", "激励"]
  },
  {
    "id": "course-ai-learning-drive",
    "title": "重建AI时代的学习驱动力",
    "category": "tension",
    "quiz_url": "/courses/course-ai-learning-drive/quiz.html",
    "handbook_url": "/courses/course-ai-learning-drive/handbook.html",
    "articleId": "ai-learning-drive",
    "summary": "AI让知道太容易，让学得有意义变难。学习驱动力三层裂变：从知道到做到（建能力自信）、从外部激励到意义建构（奖励应用）、从个体学到集体认知碰撞。搞不懂这三层，会养出一堆假装在学习的员工。",
    "modules": 1,
    "audience": "管理者、培训负责人、HR",
    "tags": ["学习驱动力", "AI", "培训"]
  },
  {
    "id": "course-ai-trust-deficit",
    "title": "修复AI时代的组织信任",
    "category": "stable",
    "quiz_url": "/courses/course-ai-trust-deficit/quiz.html",
    "handbook_url": "/courses/course-ai-trust-deficit/handbook.html",
    "articleId": "ai-trust-deficit",
    "summary": "AI答案越来越精准，人的信任却越来越虚弱——信任赤字。三重危机：信数据少了人的判断、信任通胀导致GPS依赖症、敢不信AI成稀缺能力。健康组织是AI说了之后人还能辩一辩、用判断力做决定。",
    "modules": 1,
    "audience": "管理者、HR、决策者",
    "tags": ["信任赤字", "AI", "决策"]
  },
  {
    "id": "course-order-collapse",
    "title": "从秩序型组织走向弹性型组织",
    "category": "disrupted",
    "quiz_url": "/courses/course-order-collapse/quiz.html",
    "handbook_url": "/courses/course-order-collapse/handbook.html",
    "articleId": "order-collapse",
    "summary": "AI最擅长执行标准流程，以秩序为核心竞争力的组织正被底层替代。三种坍塌：执行力溢价归零、层级瓦解、规则成围墙。把标准化交给AI、把判断力留给人的弹性型组织才是新形态。",
    "modules": 1,
    "audience": "管理者、创业者、组织发展",
    "tags": ["秩序型组织", "AI", "组织变革"]
  },
  {
    "id": "course-org-slim-trap",
    "title": "避开AI时代的组织瘦身陷阱",
    "category": "tension",
    "quiz_url": "/courses/course-org-slim-trap/quiz.html",
    "handbook_url": "/courses/course-org-slim-trap/handbook.html",
    "articleId": "org-slim-trap",
    "summary": "AI裁员看似降本增效，剩下的人却快崩溃。三大代价：减人不减事、带走隐性资产、幸存者综合征。跳出效率单层，用事/人/关系三层次框架看组织，别用长期健康支付短期成本。",
    "modules": 1,
    "audience": "管理者、HR、创业者",
    "tags": ["组织瘦身", "AI", "裁员", "组织健康"]
  },
  {
    "id": "course-decision-outsourcing",
    "title": "保住AI时代的组织判断力",
    "category": "stable",
    "quiz_url": "/courses/course-decision-outsourcing/quiz.html",
    "handbook_url": "/courses/course-decision-outsourcing/handbook.html",
    "articleId": "decision-outsourcing",
    "summary": "决策外包是AI时代最隐蔽的管理衰退。省下每次决策的10分钟，丢掉判断力。决策肌肉理论：能力和肌肉一样用进废退。划清三类决策的AI介入边界，别让省下的10分钟吃掉组织判断力。",
    "modules": 1,
    "audience": "管理者、决策者",
    "tags": ["决策外包", "AI", "判断力", "管理衰退"]
  },
  {
    "id": "course-org-radar-paradox",
    "title": "从组织监控力到组织免疫力",
    "category": "created",
    "quiz_url": "/courses/course-org-radar-paradox/quiz.html",
    "handbook_url": "/courses/course-org-radar-paradox/handbook.html",
    "articleId": "org-radar-paradox",
    "summary": "异常预警越灵敏，组织越窒息——组织雷达悖论。组织需要运维噪声和缓冲空间，不能把一切当异常。AI诊断有三大失灵。建组织免疫力而非监控力，让组织能承受、消化、转译异常。",
    "modules": 1,
    "audience": "管理者、CHO、HR",
    "tags": ["组织诊断", "AI", "组织免疫力", "组织健康"]
  },
  {
    "id": "course-craft-devaluation",
    "title": "手艺贬值时代，建你自己的护城河",
    "category": "eliminated",
    "quiz_url": "/courses/course-craft-devaluation/quiz.html",
    "handbook_url": "/courses/course-craft-devaluation/handbook.html",
    "articleId": "craft-devaluation",
    "summary": "手工艺一直在贬值，只是以前慢现在快。真正被淘汰的不是手艺人，是只会一手的人。比手艺更值钱的是判断力、决策力、审美与整合能力。别守着手艺，去建护城河。",
    "modules": 1,
    "audience": "管理者、专业人士、创业者",
    "tags": ["手艺贬值", "AI", "职业发展", "护城河"]
  },
  {
    "id": "course-sme-ai-efficiency",
    "title": "中小企业抢AI效率红利",
    "category": "tension",
    "quiz_url": "/courses/course-sme-ai-efficiency/quiz.html",
    "handbook_url": "/courses/course-sme-ai-efficiency/handbook.html",
    "articleId": "sme-ai-efficiency",
    "summary": "抢AI人才是大厂的游戏，不是你的游戏。中小企业的AI红利是用AI把成本打到地板。三棒斧先赢今天的仗。中小企业真正的护城河是AI给不了的那个东西。",
    "modules": 1,
    "audience": "中小企业主、创业者、管理者",
    "tags": ["中小企业", "AI", "效率", "护城河"]
  },
  {
    "id": "course-statistical-thinking",
    "title": "补上AI时代的统计思维",
    "category": "created",
    "quiz_url": "/courses/course-statistical-thinking/quiz.html",
    "handbook_url": "/courses/course-statistical-thinking/handbook.html",
    "articleId": "statistical-thinking",
    "summary": "数据越来越便宜，看懂数据越来越贵。统计思维不是让你算数，是让你别被数据骗。组织管理里的统计思维，是AI替代不了的判断力。判断力不是算力。",
    "modules": 1,
    "audience": "管理者、决策者、分析岗",
    "tags": ["统计思维", "AI", "判断力", "数据"]
  },
  {
    "id": "course-ai-xinqi-inflation",
    "title": "养回AI时代的心气",
    "category": "stable",
    "quiz_url": "/courses/course-ai-xinqi-inflation/quiz.html",
    "handbook_url": "/courses/course-ai-xinqi-inflation/handbook.html",
    "articleId": "ai-xinqi-inflation",
    "summary": "AI把困难都抹平了，团队的心气正在悄悄贬值。心气长在'克服困难'里，AI替人克服，人就长不出心气。当所有人都用同一批AI，'想做得更好'的心气就是组织最后的护城河。",
    "modules": 1,
    "audience": "管理者、团队负责人、创业者",
    "tags": ["心气", "AI", "组织动力", "士气"]
  },
  {
    "id": "course-ai-slow-capability",
    "title": "养回AI时代的慢能力",
    "category": "eliminated",
    "quiz_url": "/courses/course-ai-slow-capability/quiz.html",
    "handbook_url": "/courses/course-ai-slow-capability/handbook.html",
    "articleId": "ai-slow-capability",
    "summary": "AI把'执行的速度'打成白菜价，快成了标配、一文不值。被淘汰的不是'慢活'，是'愿意慢慢想的人'。判断力是慢能力养出来的，AI给不了也抄不走。",
    "modules": 1,
    "audience": "管理者、决策者、创意岗",
    "tags": ["慢能力", "AI", "深度思考", "判断力"]
  },
  {
    "id": "course-ai-mistake-notebook",
    "title": "重建组织的错题本",
    "category": "created",
    "quiz_url": "/courses/course-ai-mistake-notebook/quiz.html",
    "handbook_url": "/courses/course-ai-mistake-notebook/handbook.html",
    "articleId": "ai-mistake-notebook",
    "summary": "AI不让你犯错，把'犯错—复盘—改进'闭环的第一个环节掐断了，组织就学不到东西。在'不犯错'成标配的时代，主动留住错误、从错误学习，成了组织的新稀缺资产。",
    "modules": 1,
    "audience": "管理者、团队负责人、学习官",
    "tags": ["错题本", "AI", "组织学习", "复盘"]
  },
  {
    "id": "course-ai-professional-divide",
    "title": "弥合AI时代的专业分化",
    "category": "tension",
    "quiz_url": "/courses/course-ai-professional-divide/quiz.html",
    "handbook_url": "/courses/course-ai-professional-divide/handbook.html",
    "articleId": "ai-professional-divide",
    "summary": "AI时代正在撕裂组织的专业分化。根子不在AI，在专业性认同。拥抱AI和抗拒AI的人互相鄙视、信息隔离，比技术本身更危险。破局：别谈技术谈价值，重新定义每个岗位在AI时代的贡献。",
    "modules": 1,
    "audience": "管理者、HR、团队负责人",
    "tags": ["专业分化", "AI", "组织撕裂"]
  },
  {
    "id": "course-ai-ability-checklist",
    "title": "重建AI时代的核心能力清单",
    "category": "created",
    "quiz_url": "/courses/course-ai-ability-checklist/quiz.html",
    "handbook_url": "/courses/course-ai-ability-checklist/handbook.html",
    "articleId": "ai-ability-checklist",
    "summary": "被AI拉平的不是能力是技能。技能可外包给AI，能力不能。不依赖AI的核心能力：判断力、提问力、整合力、责任感。组织要重新定义的不是工具，是会什么。别再用会用AI当标准让所有人被拉平。",
    "modules": 1,
    "audience": "管理者、HR、招聘负责人",
    "tags": ["能力清单", "AI", "人才标准"]
  },
  {
    "id": "course-ai-training-failure",
    "title": "拯救失效的企业培训",
    "category": "disrupted",
    "quiz_url": "/courses/course-ai-training-failure/quiz.html",
    "handbook_url": "/courses/course-ai-training-failure/handbook.html",
    "articleId": "ai-training-failure",
    "summary": "AI让知识免费，企业培训价值锚点消失。旧培训三柱（知识差/纪律约束/认证价值）断裂。培训要卖行为改变+认知升级+群体能量。走向第二曲线：行为场/项目制/机制设计（游戏化）。AI淘汰的是只会讲知识的培训师。",
    "modules": 1,
    "audience": "培训负责人、HR、管理者、培训师",
    "tags": ["培训失效", "AI", "游戏化", "行为改变"]
  },
  {
    "id": "course-ai-gray-judgment",
    "title": "找回AI时代的灰度判断力",
    "category": "tension",
    "quiz_url": "/courses/course-ai-gray-judgment/quiz.html",
    "handbook_url": "/courses/course-ai-gray-judgment/handbook.html",
    "articleId": "ai-gray-judgment",
    "summary": "AI让管理变成参数调节，判断力去哪了？灰度判断力是AI时代的稀缺品。AI擅长处理非黑即白的规则、确定性的问题；真正复杂的管理是灰度地带，需要人的判断。别把一切决策都参数化。",
    "modules": 1,
    "audience": "管理者、决策者",
    "tags": ["灰度判断", "AI", "决策"]
  },
  {
    "id": "course-ai-org-warning-failure",
    "title": "重建AI时代的组织预警",
    "category": "tension",
    "quiz_url": "/courses/course-ai-org-warning-failure/quiz.html",
    "handbook_url": "/courses/course-ai-org-warning-failure/handbook.html",
    "articleId": "ai-org-warning-failure",
    "summary": "数据满格，决定还是晚了——组织预警失灵。AI预警系统拉响警报但没人行动，或预警过多变成狼来了。问题在预警触发的不是决策而是焦虑。重建预警，让预警真正驱动决策。",
    "modules": 1,
    "audience": "管理者、CHO、运营负责人",
    "tags": ["组织预警", "AI", "数据"]
  },
  {
    "id": "course-ai-org-stop-loss",
    "title": "掌握AI时代的组织止损",
    "category": "created",
    "quiz_url": "/courses/course-ai-org-stop-loss/quiz.html",
    "handbook_url": "/courses/course-ai-org-stop-loss/handbook.html",
    "articleId": "ai-org-stop-loss",
    "summary": "当AI告诉你该赚的钱，你却不该赚了——组织止损决策。AI算出最优收益，但组织有声誉、人心、长期主义这些AI算不出的账。止损不只是砍掉亏损，也包括拒绝不该赚的钱。",
    "modules": 1,
    "audience": "管理者、创业者、决策者",
    "tags": ["止损", "AI", "长期主义"]
  },
  {
    "id": "course-ai-employment-retreat",
    "title": "掌握AI时代的雇佣退场",
    "category": "tension",
    "quiz_url": "/courses/course-ai-employment-retreat/quiz.html",
    "handbook_url": "/courses/course-ai-employment-retreat/handbook.html",
    "articleId": "ai-employment-retreat",
    "summary": "当2亿人不再属于任何一家公司——闲置雇佣制的退场。雇佣制\"用固定成本换稳定协作\"的底层逻辑被AI按需调用的经济账算掉。三重代价：失去沉淀容器、管理退化成对接、个体独自承担风险。",
    "modules": 1,
    "audience": "管理者、HR负责人、创业者",
    "tags": ["雇佣关系", "灵活就业", "AI", "组织效率"]
  },
  {
    "id": "course-ai-risk-footnote",
    "title": "掌握AI时代的风险脚注",
    "category": "stable",
    "quiz_url": "/courses/course-ai-risk-footnote/quiz.html",
    "handbook_url": "/courses/course-ai-risk-footnote/handbook.html",
    "articleId": "ai-risk-footnote",
    "summary": "当发出警告的人先被边缘化。组织对风险失明的根本原因不是认知问题而是结构问题——看见风险的人没有能安全说话的位置。把提风险写进岗位职责、风险分级、给踩刹车的人正向回报。",
    "modules": 1,
    "audience": "管理者、CHO、风控负责人",
    "tags": ["风险管理", "心理安全感", "AI", "组织决策"]
  },
  {
    "id": "course-ai-permission-blackhole",
    "title": "掌握AI时代的权限黑洞",
    "category": "eliminated",
    "quiz_url": "/courses/course-ai-permission-blackhole/quiz.html",
    "handbook_url": "/courses/course-ai-permission-blackhole/handbook.html",
    "articleId": "ai-permission-blackhole",
    "summary": "17小时删掉89TB，没人拦得住。权限黑洞=破坏力与管控力的剪刀差。破法：双人确认、实时告警、权限保质期、演练恢复。",
    "modules": 1,
    "audience": "管理者、技术负责人、风控负责人",
    "tags": ["权限管理", "数据安全", "AI", "风控"]
  },
  {
    "id": "course-ai-unsexy-work",
    "title": "掌握AI时代的去包装化能力",
    "category": "tension",
    "quiz_url": "/courses/course-ai-unsexy-work/quiz.html",
    "handbook_url": "/courses/course-ai-unsexy-work/handbook.html",
    "articleId": "ai-unsexy-work",
    "summary": "从微博热榜\"用AI裁了70多人利润就上去了\"切入：AI能压缩的是可包装、可分工的岗位，而整合力、责任承担、判断这些\"不性感\"的能力反而更贵。组织在裁掉\"说服型\"岗位，也在丢掉自己的主张能力。",
    "modules": 1,
    "audience": "管理者、创业者、HR负责人",
    "tags": ["AI", "组织能力", "降本增效", "判断力"]
  },
  {
    "id": "course-ai-criteria-hollowing",
    "title": "掌握AI时代的标准空心化",
    "category": "eliminated",
    "quiz_url": "/courses/course-ai-criteria-hollowing/quiz.html",
    "handbook_url": "/courses/course-ai-criteria-hollowing/handbook.html",
    "articleId": "ai-criteria-hollowing",
    "summary": "从知乎热榜\"番茄AI文占比74.5%\"切入：当AI让人人都能达标，标准本身失去区分度。评分体系被批量生产攻破后，组织靠什么认人、兑现承诺，员工努力还有什么意义。",
    "modules": 1,
    "audience": "管理者、HR负责人、平台运营",
    "tags": ["AI", "评价体系", "标准", "激励"]
  },
  {
    "id": "course-ai-waiting-loss",
    "title": "掌握AI时代的等靠要成本",
    "category": "created",
    "quiz_url": "/courses/course-ai-waiting-loss/quiz.html",
    "handbook_url": "/courses/course-ai-waiting-loss/handbook.html",
    "articleId": "ai-waiting-loss",
    "summary": "从知乎热榜\"下属总推一下动一下，管理者该怎么提升管理能力\"切入：主动性缺失多半是等待成本低于行动成本的制度设计问题。AI让等待的成本变便宜，组织正在批量生产\"等指令的人\"。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": ["AI", "主动性", "管理机制", "组织效率"]
  },
  {
    "id": "course-ai-ai-summer-camp-failed",
    "title": "掌握AI时代的外接大脑退场",
    "category": "eliminated",
    "quiz_url": "/courses/course-ai-ai-summer-camp-failed/quiz.html",
    "handbook_url": "/courses/course-ai-ai-summer-camp-failed/handbook.html",
    "articleId": "ai-ai-summer-camp-failed",
    "summary": "从微博热榜\"9.9元AI夏令营家长抢着报名\"切入：AI淘汰的不是学习，而是以记忆和搬运为核心的\"外接大脑\"式学习。知识清单式培养、标准答案式评价、储存型职业安全感正在被淘汰，判断力才是护城河。",
    "modules": 1,
    "audience": "管理者、培训负责人、HR负责人",
    "tags": ["AI", "判断力", "培训转型", "组织能力"]
  },
  {
    "id": "course-ai-loop-economy",
    "title": "掌握AI时代的闭环能力",
    "category": "created",
    "quiz_url": "/courses/course-ai-loop-economy/quiz.html",
    "handbook_url": "/courses/course-ai-loop-economy/handbook.html",
    "articleId": "ai-loop-economy",
    "summary": "从微博热榜\"蜜雪冰城半年净赚27亿\"切入：AI把单点交付压到极便宜，于是组织瓶颈从\"做得出来\"移到\"做得完整\"。闭环=定靶、卡点、收尾、复盘四段。能闭环的组织AI是加速器，不能闭环的是混乱放大器。",
    "modules": 1,
    "audience": "管理者、创业者、团队负责人",
    "tags": ["AI", "组织效率", "闭环", "管理能力"]
  },
  {
    "id": "course-ai-startup-cost",
    "title": "掌握AI时代的上手成本",
    "category": "tension",
    "quiz_url": "/courses/course-ai-startup-cost/quiz.html",
    "handbook_url": "/courses/course-ai-startup-cost/handbook.html",
    "articleId": "ai-startup-cost",
    "summary": "从热榜\"147所高校新增人工智能专业\"切入：组织AI困境不是能力成本问题，是\"上手成本\"问题。选择成本被AI放大、没有SOP可抄、试错责任无处安放，组织永远停在准备阶段。破法：把开始变便宜、变安全。",
    "modules": 1,
    "audience": "管理者、数字化转型负责人、HR负责人",
    "tags": ["AI", "组织变革", "落地", "管理"]
  },
  {
    "id": "course-ai-responsibility-alibi",
    "title": "掌握AI时代的\"责任外挂\"",
    "category": "eliminated",
    "quiz_url": "/courses/course-ai-responsibility-alibi/quiz.html",
    "handbook_url": "/courses/course-ai-responsibility-alibi/handbook.html",
    "articleId": "ai-responsibility-alibi",
    "summary": "从热榜\"机器人比赛现场失控伤人、追责追到人\"切入：机器没有责任账户，不能被追、不能被罚、也不会因被罚而改变行为，责任必然回流到活人身上。组织若不主动重建责任分配，责任会自动淤积到最靠近现场、最没有议价权的人身上。破法：给AI环节标人类责任人、建不可逆操作清单、责任与授权同步下发、复盘只问设计不问态度",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": ["AI", "组织效率", "工作设计", "决策权"]
  },
  {
    "id": "course-ai-personal-brand-devaluation",
    "title": "掌握AI时代的\"个人品牌贬值\"",
    "category": "tension",
    "quiz_url": "/courses/course-ai-personal-brand-devaluation/quiz.html",
    "handbook_url": "/courses/course-ai-personal-brand-devaluation/handbook.html",
    "articleId": "ai-personal-brand-devaluation",
    "summary": "从热榜\"张一鸣身家破1050亿美元成亚洲首富\"切入：个人的\"名字\"正在两端剧烈分化——顶层名字越来越值钱，中层名字越来越不值钱。AI把\"作品稀缺性来自能力稀缺性且绑定于个人\"这个前提打破了。破法：判断过程显性化、积累不可复制样本库、主动署名担责、重定义自己的产品。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": ["AI", "品牌", "组织能力", "职业发展"]
  },
  {
    "id": "course-ai-novelty-debt",
    "title": "掌握AI时代的\"新鲜感负债\"",
    "category": "created",
    "quiz_url": "/courses/course-ai-novelty-debt/quiz.html",
    "handbook_url": "/courses/course-ai-novelty-debt/handbook.html",
    "articleId": "ai-novelty-debt",
    "summary": "从热榜\"别用旧样本劝年轻人勇敢\"切入：新鲜感不是激励而是刺激——刺激效用递减，真正激励会自我强化。组织不断借刺激维持短期热情，利息是激励成本越滚越高。AI时代信息过载抬高了刺激阈值、让\"有趣\"贬值。破法：把激励系统从刺激引擎换成意义引擎（自主、胜任、联结），拉长激励周期。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": ["AI", "组织效率", "韧性", "游戏化"]
  },
  {
    "id": "course-ai-credential-dividend",
    "title": "掌握AI时代的\"学历红利\"",
    "category": "tension",
    "quiz_url": "/courses/course-ai-credential-dividend/quiz.html",
    "handbook_url": "/courses/course-ai-credential-dividend/handbook.html",
    "articleId": "ai-credential-dividend",
    "summary": "从热榜\"2.7亿高学历人口，企业却招不到人\"切入：学历供给创新高，但学历作为能力信号的证明力在下降。AI让\"背知识\"彻底平价，稀缺的从\"持证\"转移到\"能验证产出\"。破法：招聘用任务样本替代标签、培训从教知识改为校准判断、晋升从年限改为可验证产出。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "招聘",
        "人才",
        "组织能力"
    ]
},
  {
    "id": "course-ai-product-sunset",
    "title": "掌握AI时代的\"边缘产品\"",
    "category": "eliminated",
    "quiz_url": "/courses/course-ai-product-sunset/quiz.html",
    "handbook_url": "/courses/course-ai-product-sunset/handbook.html",
    "articleId": "ai-product-sunset",
    "summary": "从热榜\"连做AI的公司都在砍自己的产品\"切入：AI把研发成本压到极低，产品数量爆炸，却没人负责到底。问题不在要不要用AI，而在谁会为一个产品持续负责。破法：事先写死退役标准、指定长期owner、公开每个产品为谁解决什么。",
    "modules": 1,
    "audience": "管理者、产品负责人、创业者",
    "tags": [
        "AI",
        "产品管理",
        "组织效率",
        "负责制"
    ]
},
  {
    "id": "course-ai-acceptance-ability",
    "title": "掌握AI时代的\"验收能力\"",
    "category": "created",
    "quiz_url": "/courses/course-ai-acceptance-ability/quiz.html",
    "handbook_url": "/courses/course-ai-acceptance-ability/handbook.html",
    "articleId": "ai-acceptance-ability",
    "summary": "AI把\"干活\"的门槛打平，稀缺的变成\"验收\"——看出结果对不对、能不能用。验收能力不在流程里，在判断标准里。破法：写死验收标准再开工、对AI产出做抽检而非全信、把返工原因记成清单沉淀成组织经验库。",
    "modules": 1,
    "audience": "管理者、团队负责人、一线骨干",
    "tags": [
        "AI",
        "质量管理",
        "判断力",
        "组织能力"
    ]
},
  {
    "id": "course-ai-ability-tax-refund",
    "title": "掌握AI时代的「能力退税」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-ability-tax-refund/quiz.html",
    "handbook_url": "/courses/course-ai-ability-tax-refund/handbook.html",
    "articleId": "ai-ability-tax-refund",
    "summary": "AI不是抢走你的工作，而是让「会做」这件事从资产变成了水电。你当年为掌握某门手艺多付出的努力溢价，正在被AI一笔一笔清算。最危险的，是你还在、title还在，但你的本事在一天天贬值。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-accountability-punishment",
    "title": "掌握AI时代的「担当惩罚」",
    "category": "eliminated",
    "quiz_url": "/courses/course-ai-accountability-punishment/quiz.html",
    "handbook_url": "/courses/course-ai-accountability-punishment/handbook.html",
    "articleId": "ai-accountability-punishment",
    "summary": "微博知乎双榜\"帮扶老人遭索赔店主不担责\"戳中一个组织管理痛点：主动担责的人收益被稀释、风险被放大，沉默的人风险为零。AI把\"担当的代价\"变成一眼可见的数字，反而精准淘汰最敢负责的人。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-alert-distortion",
    "title": "掌握AI时代的「预警失真」",
    "category": "stable",
    "quiz_url": "/courses/course-ai-alert-distortion/quiz.html",
    "handbook_url": "/courses/course-ai-alert-distortion/handbook.html",
    "articleId": "ai-alert-distortion",
    "summary": "微博\"长宁地震预警误报\"戳中一个组织管理痛点：AI预警系统越灵敏，假警报越多，人越听不见真危机。灵敏度和可信度是两码事，破解要靠分级、公开误报率、保留人的最后一道关。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-antifragile-rent",
    "title": "掌握AI时代的「反脆弱租金」",
    "category": "stable",
    "quiz_url": "/courses/course-ai-antifragile-rent/quiz.html",
    "handbook_url": "/courses/course-ai-antifragile-rent/handbook.html",
    "articleId": "ai-antifragile-rent",
    "summary": "胖东来被房东涨租逼走，却从不涨自己商户的租金。这种\"故意吃亏\"藏着AI最学不会的组织能力：反脆弱租金——主动放弃短期确定性收益，购买长期抗冲击能力。AI能算清\"看得见的账\"，算不了信任、忠诚、韧性这些\"看不见的账\"。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-application-desert",
    "title": "掌握AI时代的「应用荒漠」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-application-desert/quiz.html",
    "handbook_url": "/courses/course-ai-application-desert/handbook.html",
    "articleId": "ai-application-desert",
    "summary": "从知乎热榜\"都说GPT-6-Astra很强，有没有实际点的应用案例\"切入：强模型、好产品、组织能用是三件毫不相干的事。很多人默认\"模型强=工具好=组织一定能用起来\"是错的——组织缺的不是更强的大模型，是那条把\"强能力\"改造成\"岗位真能用\"的接缝。三道塌方：买模型不买岗位改造、用测试分冒充可用性、趁模型更新快干脆选择等。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-apprentice-employment",
    "title": "掌握AI时代的「学员制用工」",
    "category": "created",
    "quiz_url": "/courses/course-ai-apprentice-employment/quiz.html",
    "handbook_url": "/courses/course-ai-apprentice-employment/handbook.html",
    "articleId": "ai-apprentice-employment",
    "summary": "从知乎热榜\"于东来称胖东来再招员工都是学员性质、合同四年不续签\"切入：当AI让\"熟练\"变廉价，组织买\"现成能力\"的性价比崩塌，于是转向买\"可塑的过程\"——招进来不再为立刻用，而为练出AI练不出的判断力与适应力。三重变化：人从资源变成有期限的作品、招人标准从\"会什么\"变成\"能长多快\"、培训从福利变成主业务。破法：写死能力",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-asking-ability-deflation",
    "title": "掌握AI时代的「答题能力\"贬值」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-asking-ability-deflation/quiz.html",
    "handbook_url": "/courses/course-ai-asking-ability-deflation/handbook.html",
    "articleId": "ai-asking-ability-deflation",
    "summary": "AI把答案打成白菜价，把提问抬成硬通货。培训的价值从\"传授答案\"转向\"练提问\"，会问对问题才是AI时代最稀缺的能力。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-async-shift-schedule",
    "title": "掌握AI时代的「AI时代，\"错峰\"的迟到」",
    "category": "stable",
    "quiz_url": "/courses/course-ai-async-shift-schedule/quiz.html",
    "handbook_url": "/courses/course-ai-async-shift-schedule/handbook.html",
    "articleId": "ai-async-shift-schedule",
    "summary": "从微博热榜\"双休不一定是休周六周日\"切入：AI已把很多工作异步化了，可多数组织的作息还停在工业时代那套\"人人都得同时在场\"的同步宇宙里。作息从来不只是时间表，是组织权力的排列方式。AI能异步任务，异步不了权力。同步的舒适在AI时代正在变成三笔隐形代价：用同时在场掩盖没想清楚、假装同步制造表演在场、把差异化节奏当异类。破",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-authenticity-premium",
    "title": "掌握AI时代的「人设崩塌」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-authenticity-premium/quiz.html",
    "handbook_url": "/courses/course-ai-authenticity-premium/handbook.html",
    "articleId": "ai-authenticity-premium",
    "summary": "从微博热榜\"雷军澄清早餐被骂装\"切入：AI能批量生成完美形象，于是完美贬值、真实升值。组织靠表演建立的信任成本越来越高，可信才是领导力第一指标。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-beyond-resume",
    "title": "掌握AI时代的「简历之外」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-beyond-resume/quiz.html",
    "handbook_url": "/courses/course-ai-beyond-resume/handbook.html",
    "articleId": "ai-beyond-resume",
    "summary": "从微博热榜\"我国从来没有第一学历这个概念\"和知乎\"星宇股份90%劳务派遣\"切入：AI把简历从\"高成本证据\"变成了\"文案\"——既好造假、又难分辨，组织认人的坐标系塌了。三道裂缝：AI筛简历偏爱光鲜履历反而筛掉AI补不上的人、身份标签与能力脱钩、AI面试催生\"过面试\"表演产业。破法：用真活替代真简历、问未来不问过去、把身份",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-blank-space-ability",
    "title": "掌握AI时代的「留白能力」",
    "category": "stable",
    "quiz_url": "/courses/course-ai-blank-space-ability/quiz.html",
    "handbook_url": "/courses/course-ai-blank-space-ability/handbook.html",
    "articleId": "ai-blank-space-ability",
    "summary": "很多团队引入AI后效率上去了，创造力判断力却悄悄下降。因为组织把员工时间填得太满，系统性杀死了产生新想法的空间。AI省下来的时间不是用来填更多活的，是用来留白产生判断和创造。破局：把留白写进制度、用深度问题替代密集任务、容忍看似没产出的思考时间。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-boredom-tax",
    "title": "掌握AI时代的「无聊税」",
    "category": "stable",
    "quiz_url": "/courses/course-ai-boredom-tax/quiz.html",
    "handbook_url": "/courses/course-ai-boredom-tax/handbook.html",
    "articleId": "ai-boredom-tax",
    "summary": "•无聊税：AI把发呆、等待、卡壳等\"无聊时间\"全填满，每填满一分钟就少一分灵感\\n•神经科学：默认模式网络（DMN）在走神时启动，做跨领域连接——顿悟是\"无聊出来\"的不是\"想出来\"的\\n•AI三个消灭无聊的机制：填满等待空隙、消灭\"卡住\"的时间、让\"留白\"在文化上不可接受\\n•AI越强组织越需要无聊：差异化来自\"未知问",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-both-tax",
    "title": "掌握AI时代的\"既要又要税\"",
    "category": "tension",
    "quiz_url": "/courses/course-ai-both-tax/quiz.html",
    "handbook_url": "/courses/course-ai-both-tax/handbook.html",
    "articleId": "ai-both-tax",
    "summary": "微博热搜\"凭什么既要工作又要做家务\"，戳中的不只是家庭分工，还有AI时代极普遍的组织病\"既要又要税\"——老板给员工装AI说效率高了该轻松，转头却用\"你不是有AI吗\"当筹码，要人一个人扛下所有AI替代不了的人情、兜底与协调。效率归组织，内耗归个人；账单迟早爆在组织自己头上。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-certificate-inflation",
    "title": "掌握AI时代的「证书通胀」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-certificate-inflation/quiz.html",
    "handbook_url": "/courses/course-ai-certificate-inflation/handbook.html",
    "articleId": "ai-certificate-inflation",
    "summary": "知乎热榜\"王者荣耀高校认证被炒到两千元\"的背后，是AI时代一场\"证书通胀\"。AI让\"证明\"和\"能力\"之间的相关性崩了：当能力可以随时外挂、知识随手生成，一次性静态证书正在飞速贬值。可太多组织还把证当硬尺子，招错人、吓跑真高手、养出刷证文化。破局在于组织从\"看符号\"走向\"看过程、看作品、看现场\"——用真实且扛得住追问的能",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-classroom-no-phone",
    "title": "掌握AI时代的「注意力托管」",
    "category": "stable",
    "quiz_url": "/courses/course-ai-classroom-no-phone/quiz.html",
    "handbook_url": "/courses/course-ai-classroom-no-phone/handbook.html",
    "articleId": "ai-classroom-no-phone",
    "summary": "从知乎热榜\"多所高校推进无手机课堂\"切入：注意力不是被手机抢走的，是被\"不值得\"赶走的。手机只是逃生出口，收手机是堵，设计注意力才是疏。AI时代内容零成本，\"坐在这里听\"的理由被抽空；三种更高明做法：把内容变不可替代、把\"听\"换成\"做\"、给注意力一个\"值得\"的回报。组织真正该收的不是手机，是浪费注意力的环节。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-code-streaking",
    "title": "掌握AI时代的「代码裸奔」",
    "category": "eliminated",
    "quiz_url": "/courses/course-ai-code-streaking/quiz.html",
    "handbook_url": "/courses/course-ai-code-streaking/handbook.html",
    "articleId": "ai-code-streaking",
    "summary": "从知乎热榜\"智谱ZCode被质疑静默上传全量Git操作\"切入：把核心资产交给黑箱工具不是信任问题，是架构问题。组织需要的是可核查的数据流向，而不是\"大厂应该没问题\"的直觉。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-colleague-disappearing",
    "title": "掌握AI时代的「“同事关系”正在消失」",
    "category": "eliminated",
    "quiz_url": "/courses/course-ai-colleague-disappearing/quiz.html",
    "handbook_url": "/courses/course-ai-colleague-disappearing/handbook.html",
    "articleId": "ai-colleague-disappearing",
    "summary": "•AI正在成为很多人心目中“最好的同事”\\n•同事关系“空心化”：协作功能被替代，深层关系价值也在消失\\n•三个正在被侵蚀的场景：问AI替代问同事、各自找AI替代一起解决问题、情绪外包给AI\\n•组织必须主动设计“必须真人协作”的环节\\n•AI是最好的同事，但最好的同事不应该是AI",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-competition-illusion",
    "title": "掌握AI时代的「参赛错觉」",
    "category": "stable",
    "quiz_url": "/courses/course-ai-competition-illusion/quiz.html",
    "handbook_url": "/courses/course-ai-competition-illusion/handbook.html",
    "articleId": "ai-competition-illusion",
    "summary": "宇树机器人100米垫底戳中AI落地的真相：展示价值和实用价值是两码事。别光让AI跑得好看，先让它跑得起来、跑得值。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-complaint-tax",
    "title": "掌握AI时代的「吐槽税」",
    "category": "stable",
    "quiz_url": "/courses/course-ai-complaint-tax/quiz.html",
    "handbook_url": "/courses/course-ai-complaint-tax/handbook.html",
    "articleId": "ai-complaint-tax",
    "summary": "•吐槽税：AI把\"解决问题\"变得太快太顺，组织悄悄失去\"吐槽\"这种最灵敏的预警信息\\n•吐槽是免费的咨询报告：问题信号+情绪权重，情绪越强问题越真；没人吐槽不是变好了，是没人信了\\n•三个静音机制：AI客服温柔拦截、吐槽书面化消灭情绪、内部吐槽渠道化死亡（沉默退出）\\n•代价：显性冲突被消灭，隐性流失来收利息——报表好",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-compute-pricing-power",
    "title": "掌握AI时代的「算力定价权」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-compute-pricing-power/quiz.html",
    "handbook_url": "/courses/course-ai-compute-pricing-power/handbook.html",
    "articleId": "ai-compute-pricing-power",
    "summary": "DeepSeek正式涨价上了热搜，全网在算成本。但真正该焦虑的不是算力账单，而是从没想明白\"AI到底值多少钱\"的组织。算力便宜时，定价权在厂商；AI成为核心生产工具后，定价权转向那些\"算着用AI\"的组织。三笔账，帮你把AI从信仰变回工具。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-compute-rhythm",
    "title": "掌握AI时代的「算力作息」",
    "category": "created",
    "quiz_url": "/courses/course-ai-compute-rhythm/quiz.html",
    "handbook_url": "/courses/course-ai-compute-rhythm/handbook.html",
    "articleId": "ai-compute-rhythm",
    "summary": "DeepSeek周末统一按低谷价收费，AI第一次有了像人一样的\"作息\"。当算力成本开始分峰谷，组织该重新学会错峰与休息。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-contribution-architect",
    "title": "掌握AI时代的「贡献架构师」",
    "category": "created",
    "quiz_url": "/courses/course-ai-contribution-architect/quiz.html",
    "handbook_url": "/courses/course-ai-contribution-architect/handbook.html",
    "articleId": "ai-contribution-architect",
    "summary": "当AI能伪造一切产出，那个最贵的岗位是能说清楚\"什么才算贡献\"的人。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-copycat-race",
    "title": "掌握AI时代的「搬运工内卷」",
    "category": "stable",
    "quiz_url": "/courses/course-ai-copycat-race/quiz.html",
    "handbook_url": "/courses/course-ai-copycat-race/handbook.html",
    "articleId": "ai-copycat-race",
    "summary": "抖音热榜\"各省文旅都成搬运工\"(九百多万热度)背后，是AI时代所有靠\"抄得快\"活着的组织的集体焦虑。AI把模仿门槛铲平了：凡是能被写成SOP、喂给工具复制的东西，对手都能一键抄走你，还能比你快。可复制的优势正在被AI全部归零，真护城河只剩AI抄不走的判断、信任和现场感。组织要从\"复制热门的速度\"转向\"定义下一个别人要抄",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-cost-cutting-addiction",
    "title": "掌握AI时代的「节流成瘾」",
    "category": "stable",
    "quiz_url": "/courses/course-ai-cost-cutting-addiction/quiz.html",
    "handbook_url": "/courses/course-ai-cost-cutting-addiction/handbook.html",
    "articleId": "ai-cost-cutting-addiction",
    "summary": "AI让\"省钱\"变得又快又爽，组织集体患上节流成瘾，把\"省\"从手段变成了目的。可省有天花板，增长没有；省和增练的是两套完全不同的能力。一个节流成瘾的组织，会慢慢丧失做增长的资格。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-cost-illusion",
    "title": "掌握AI时代的「降本幻觉」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-cost-illusion/quiz.html",
    "handbook_url": "/courses/course-ai-cost-illusion/handbook.html",
    "articleId": "ai-cost-illusion",
    "summary": "微博热搜\"100万房贷月供可减少635元\"的确定性快感，正像组织看到AI省下人力成本时的喜悦——可AI降本往往只有第一年确定。会降本的组织算总账：算全成本看净额、追踪省下的时间去向、设验证周期、警惕为降本而降本。省下的是死钱，投回去才是活钱。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-creative-deflation",
    "title": "掌握AI时代的「创意通缩」",
    "category": "created",
    "quiz_url": "/courses/course-ai-creative-deflation/quiz.html",
    "handbook_url": "/courses/course-ai-creative-deflation/handbook.html",
    "articleId": "ai-creative-deflation",
    "summary": "内容生产变便宜了，但创意（决定生产什么的判断）反而更值钱。AI打平了\"生产\"，让合格变成地板、平庸一文不值。护城河从\"能产出\"移位到\"敢取舍、有品味、有立场\"。不贬值的三样：判断力、品味、真诚。别跟AI比生产，跟它比判断。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-creativity-depreciation",
    "title": "掌握AI时代的「创意折旧」",
    "category": "created",
    "quiz_url": "/courses/course-ai-creativity-depreciation/quiz.html",
    "handbook_url": "/courses/course-ai-creativity-depreciation/handbook.html",
    "articleId": "ai-creativity-depreciation",
    "summary": "从微博热榜\"iPhone18ProMax 1T翻车\"切入：堆参数堆不出好东西，堆产出也堆不出价值。一件东西值多少钱，取决于它有多难被复制。AI把\"可生成\"的产出价格打到地板，组织还在按产出量考核，等于系统性奖励数量、惩罚判断。三种不折旧资产：判断力、信任与关系、专属的现场。能被生成的都会贬值，不能被盗走的才会升值。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-creator-exodus",
    "title": "掌握AI时代的「创作者停更潮」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-creator-exodus/quiz.html",
    "handbook_url": "/courses/course-ai-creator-exodus/handbook.html",
    "articleId": "ai-creator-exodus",
    "summary": "微博热搜\"大批AI博主停更了\"，老邓看到的不是流量红利尽了，而是AI让产出不再稀缺、意义感塌陷。组织里的\"内容空心化\"，才是AI时代最隐蔽的危机。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-data-asset",
    "title": "掌握AI时代的「数据产权」",
    "category": "created",
    "quiz_url": "/courses/course-ai-data-asset/quiz.html",
    "handbook_url": "/courses/course-ai-data-asset/handbook.html",
    "articleId": "ai-data-asset",
    "summary": "从抖音热榜\"首批数据产权身份证发放\"切入：AI把能力变成公共品，唯一能拉开差距的是别人拿不到的独有数据。组织应像经营资产一样经营数据。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-decision-regret-right",
    "title": "掌握AI时代的「决策剩余\"消失」",
    "category": "disrupted",
    "quiz_url": "/courses/course-ai-decision-regret-right/quiz.html",
    "handbook_url": "/courses/course-ai-decision-regret-right/handbook.html",
    "articleId": "ai-decision-regret-right",
    "summary": "•\"决策剩余\"：因为你的判断比别人更准而获得的超额回报\\n•AI消灭决策剩余的三种机制：判断力通胀、判断过程黑盒化、决策同质化\\n•核心悖论：决策质量在上升，但个人决策能力在下降（做决策≠发展决策能力）\\n•三类判断中，数据型判断的溢价正在消失，价值观判断的溢价在升值\\n•守住决策剩余的四原则：裸判、非数据经验、过程考",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-demo-report-retired",
    "title": "掌握AI时代的「汇报表演\"退场」",
    "category": "eliminated",
    "quiz_url": "/courses/course-ai-demo-report-retired/quiz.html",
    "handbook_url": "/courses/course-ai-demo-report-retired/handbook.html",
    "articleId": "ai-demo-report-retired",
    "summary": "当AI一分钟就能生成挑不出毛病的PPT、把报告润色到无懈可击，靠\"汇报好看\"上位的那套打法就没了土壤。AI把汇报里\"关于包装\"的部分全自动化，汇报不再是稀缺的\"能力信号\"。真正让管理者立足的，正从\"讲得好不好\"转向AI帮不了的部分——\"干得真不真、扛不扛得住追问\"。组织该把信任从\"会场\"搬回\"现场\"。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-draft-disappearing",
    "title": "掌握AI时代的「草稿思维\"消亡」",
    "category": "eliminated",
    "quiz_url": "/courses/course-ai-draft-disappearing/quiz.html",
    "handbook_url": "/courses/course-ai-draft-disappearing/handbook.html",
    "articleId": "ai-draft-disappearing",
    "summary": "•草稿思维是\"思考的脚手架\"：外化思考、允许试错、留下轨迹——写的过程就是想的过程\\n•AI三个机制让草稿消失：终稿太便宜被一步到位、\"粗糙\"不可见只敢在成品上修补、思考过程失去记录\\n•代价三层：个体能力被架空（思考能力是写出来的）、团队协作失去\"过程\"、组织创新失去\"念头土壤\"\\n•AI只能替代\"想清楚之后的事\"，",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-effort-inflation",
    "title": "掌握AI时代的「努力通胀」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-effort-inflation/quiz.html",
    "handbook_url": "/courses/course-ai-effort-inflation/handbook.html",
    "articleId": "ai-effort-inflation",
    "summary": "AI时代的\"努力通胀\"——当AI让产出变便宜，努力本身正在贬值 上个月一个做电商的老板跟我吃饭，说了句让我琢磨很久的话：\"我的团队人均产出翻了一倍，但我越来越不知道该奖励谁了。\" 以前很简单——谁加班到深夜、谁把方案磨了三遍、谁周末还在盯数据，一眼就看得到，奖励给这些\"最努力的人\"准没错。现在呢？方案AI十分钟出一版，",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-empowerment-anxiety",
    "title": "掌握AI时代的「赋能焦虑」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-empowerment-anxiety/quiz.html",
    "handbook_url": "/courses/course-ai-empowerment-anxiety/handbook.html",
    "articleId": "ai-empowerment-anxiety",
    "summary": "微博热搜\"AI赋能新电商发展\"背后藏着一个误区：很多组织把\"授工具\"当成了\"赋能\"。工具是借来的，能力是长出来的。AI时代组织真正该赋能的是判断力和创造力，而不是让员工更依赖工具。破局：从授工具转向赋能力，分场景集中发力，把判断力创造力放进赋能清单。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-energy-stratification",
    "title": "掌握AI时代的「精力分层」",
    "category": "stable",
    "quiz_url": "/courses/course-ai-energy-stratification/quiz.html",
    "handbook_url": "/courses/course-ai-energy-stratification/handbook.html",
    "articleId": "ai-energy-stratification",
    "summary": "微博\"发现高精力和高体力是两种人群\"戳中一个人才管理盲区：精力分爆发力和续航力两种，但KPI只认爆发力。AI替代了\"机械的稳定\"，却让管理者误以为\"有判断的稳定\"也没用了。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-ensemble-judgment",
    "title": "掌握AI时代的「独断困境」",
    "category": "created",
    "quiz_url": "/courses/course-ai-ensemble-judgment/quiz.html",
    "handbook_url": "/courses/course-ai-ensemble-judgment/handbook.html",
    "articleId": "ai-ensemble-judgment",
    "summary": "AI让每个人都握着自己那份\"完美答案\"，开会从\"吵想法\"变成\"各说各的AI\"。独断困境正在稀释组织的共识能力，重建“共同判断”成了AI时代管理者最值钱的手艺。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-error-conspiracy",
    "title": "掌握AI时代的「误差合谋」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-error-conspiracy/quiz.html",
    "handbook_url": "/courses/course-ai-error-conspiracy/handbook.html",
    "articleId": "ai-error-conspiracy",
    "summary": "•\"误差合谋\"的核心：人的偏见通过历史数据传给AI，AI再以\"科学化\"方式放大输出，形成自我强化闭环\\n•三步传导：人的偏见→偏差数据→AI制造\"科学化\"偏见结论→人的偏见被进一步强化\\n•三个真实场景：绩效评估的刻板印象放大器、人才选拔的路径依赖陷阱、协作评估的安静者惩罚\\n•三种形态：数据偏见→算法偏见、框架偏见→",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-exp-depreciation",
    "title": "掌握AI时代的「经验贬值速度」",
    "category": "eliminated",
    "quiz_url": "/courses/course-ai-exp-depreciation/quiz.html",
    "handbook_url": "/courses/course-ai-exp-depreciation/handbook.html",
    "articleId": "ai-exp-depreciation",
    "summary": "今天熬夜学会的新工具，几个月后可能就过时了。AI时代最残酷的，不是「技不如人」，而是「你刚学会，它就过时了」。学习从投资变成消费，越学越焦虑。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-explanation-tax",
    "title": "掌握AI时代的「解释税」",
    "category": "eliminated",
    "quiz_url": "/courses/course-ai-explanation-tax/quiz.html",
    "handbook_url": "/courses/course-ai-explanation-tax/handbook.html",
    "articleId": "ai-explanation-tax",
    "summary": "AI最擅长给答案，却最不擅长给理由。当管理者习惯\"AI说行就行\"，一种隐蔽的能力正在被收税：思考和解释的能力。三笔欠账（对上、对下、对己）掏空管理者的号召力。把AI当顾问、先想后问、翻译复述，三步夺回解释权。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-first-draft-anchor",
    "title": "掌握AI时代的「第一稿锚定」",
    "category": "stable",
    "quiz_url": "/courses/course-ai-first-draft-anchor/quiz.html",
    "handbook_url": "/courses/course-ai-first-draft-anchor/handbook.html",
    "articleId": "ai-first-draft-anchor",
    "summary": "AI时代的\"第一稿锚定\"——当AI先开口，你的思考已经被钉死了 起因是一件小事。上周我要给一家企业做游戏化方案，动笔前习惯性地让AI先出一版\"框架参考\"。AI三秒钟给了我一个结构：痛点分析、激励机制、落地路径、效果评估——四平八稳，看着没毛病。 然后我发现，接下来两个小时，我所有的思考都在这个框架里打转。我想加点东西，",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-flagship-product",
    "title": "掌握AI时代的「拳头产品病」",
    "category": "eliminated",
    "quiz_url": "/courses/course-ai-flagship-product/quiz.html",
    "handbook_url": "/courses/course-ai-flagship-product/handbook.html",
    "articleId": "ai-flagship-product",
    "summary": "拳头产品是奖状不是护身符。AI时代淘汰的不是产品落后的公司，是丧失了迭代能力的公司。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-flow-state-break",
    "title": "掌握AI时代的「心流断裂」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-flow-state-break/quiz.html",
    "handbook_url": "/courses/course-ai-flow-state-break/handbook.html",
    "articleId": "ai-flow-state-break",
    "summary": "•心流断裂：AI把任务拆得更碎、响应更快，人越来越难进入沉浸连贯的深度思考\\n•心流贵在\"进入成本\"——约20-30分钟预热，打断一次全部作废，一天被打断5次等于白烧2小时\\n•三个掐断机制：交互从\"批量\"变\"实时\"、AI把\"输出\"提前把\"思考预热\"架空、多任务并行被零成本合法化\\n•效率指标看不见它：浅层效率全线飘红",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-fullscore-inflation",
    "title": "掌握AI时代的「满分通胀」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-fullscore-inflation/quiz.html",
    "handbook_url": "/courses/course-ai-fullscore-inflation/handbook.html",
    "articleId": "ai-fullscore-inflation",
    "summary": "从抖音热榜\"创大要打百分了\"切入：AI垫高所有人的绝对产出，组织的合格线被拖着不断上移，员工付出增长的努力却换回没变的评价。破法是放弃绝对分数，转向相对成长。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-gacha-incentive",
    "title": "掌握AI时代的「氪金激励」",
    "category": "stable",
    "quiz_url": "/courses/course-ai-gacha-incentive/quiz.html",
    "handbook_url": "/courses/course-ai-gacha-incentive/handbook.html",
    "articleId": "ai-gacha-incentive",
    "summary": "知乎热榜问手游为何陷入\"不氪就没法舒服玩\"的死循环，我却看到大量组织患同样的病——靠不断加码的外部奖励买动力。AI恰好把这条氪金路越修越窄：稀缺技能变便宜、加码不可持续、激励稀缺性被抹平。真正该做的是回归内在动力，让AI释放人的高价值劳动。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-gamification-self-indulgence",
    "title": "掌握AI时代的「游戏化的\"自嗨陷阱」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-gamification-self-indulgence/quiz.html",
    "handbook_url": "/courses/course-ai-gamification-self-indulgence/handbook.html",
    "articleId": "ai-gamification-self-indulgence",
    "summary": "知乎\"750万影游《恶校游戏》好评93%却一周解散\"戳中游戏化行业的致命问题：作品认可不等于商业成立，形式自嗨不等于激活动机。企业游戏化正在犯一模一样的病。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-genius-illusion",
    "title": "掌握AI时代，别赌\"天才力挽狂澜\"",
    "category": "stable",
    "quiz_url": "/courses/course-ai-genius-illusion/quiz.html",
    "handbook_url": "/courses/course-ai-genius-illusion/handbook.html",
    "articleId": "ai-genius-illusion",
    "summary": "抖音热榜挂着\"AI圈来了位天才\"上千万播放，我却替那些看得心痒的老板捏把汗。组织持续赢靠的不是一两个天才，而是让普通人做出不普通结果的系统。赌\"救世主员工\"的是用不可控的运气替代本可系统化建设的组织能力——AI时代单干门槛极低，真有天才凭什么来给你打工？与其赌奇迹，不如把系统、主场、协作三块地基夯实。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-group-chat-bubble",
    "title": "掌握AI时代的「群聊泡沫」",
    "category": "eliminated",
    "quiz_url": "/courses/course-ai-group-chat-bubble/quiz.html",
    "handbook_url": "/courses/course-ai-group-chat-bubble/handbook.html",
    "articleId": "ai-group-chat-bubble",
    "summary": "微博热搜\"女孩被踢出845个工作群\"背后，是组织沟通的通胀陷阱。工具让发消息成本趋近于零，人人都无限拉群@人，信息从稀缺品变成过剩品。AI不是解药反而可能让泡沫更鼓——它降低了生产消息的门槛，却没降低接收消息的负担。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-hallucination-auditor",
    "title": "掌握AI时代的「AI幻觉审查员」",
    "category": "newroles",
    "quiz_url": "/courses/course-ai-hallucination-auditor/quiz.html",
    "handbook_url": "/courses/course-ai-hallucination-auditor/handbook.html",
    "articleId": "ai-hallucination-auditor",
    "summary": "•AI幻觉根源：AI本质是\"预测下一个词\"而非\"查资料\"，追求\"像\"不是\"真\"，接入数据库只能减少不能根除\\n•幻觉三个放大器：权威感包装、上下文污染、规模效应\\n•幻觉审查员四层职责：事实核验（逐条溯源）、逻辑审计（追问推理链）、风险分级（按错误后果分绿黄红区）、反馈闭环\\n•最适合转行的三类人：资深业务专家、调查记",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-hard-problem-accountant",
    "title": "掌握AI时代的「攻坚算账人」",
    "category": "created",
    "quiz_url": "/courses/course-ai-hard-problem-accountant/quiz.html",
    "handbook_url": "/courses/course-ai-hard-problem-accountant/handbook.html",
    "articleId": "ai-hard-problem-accountant",
    "summary": "从微博热榜\"OpenAI宣布攻克千禧年难题\"切入一个被忽略的事实：AI最擅长解定义清楚的难题，可组织里80%耗人的是说不清该不该解的小破题。于是出现攻坚错配——把最强能力用在最难最远的题上，近处天天漏血却没人管值不值得用AI。组织真正的瓶颈从不是能解多少题，而是把资源浪费在多少根本不该解的题上。所以现在最贵的是能判别哪",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-hidden-knowledge-completion",
    "title": "掌握AI时代的「认知补全」",
    "category": "stable",
    "quiz_url": "/courses/course-ai-hidden-knowledge-completion/quiz.html",
    "handbook_url": "/courses/course-ai-hidden-knowledge-completion/handbook.html",
    "articleId": "ai-hidden-knowledge-completion",
    "summary": "抖音\"AI补全了长辈的未知\"刷屏，戳中一个更冷的真相：AI能补全显性知识，却补不全组织最值钱的隐性经验。AI越强，人越懒得沉淀，“老油条”的经验正在静默流失。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-high-risk-list-trap",
    "title": "掌握AI时代的「高危名单\"陷阱」",
    "category": "eliminated",
    "quiz_url": "/courses/course-ai-high-risk-list-trap/quiz.html",
    "handbook_url": "/courses/course-ai-high-risk-list-trap/handbook.html",
    "articleId": "ai-high-risk-list-trap",
    "summary": "从知乎热榜钟南山团队研究\"73%肺癌来自非高危人群\"切入：任何\"重点盯防\"的系统同时是\"系统性忽视\"的系统。组织用AI做盘点、监控、预警时，最大的漏网之鱼往往不在高危名单里。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-human-screws",
    "title": "掌握AI时代的「人肉螺丝」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-human-screws/quiz.html",
    "handbook_url": "/courses/course-ai-human-screws/handbook.html",
    "articleId": "ai-human-screws",
    "summary": "微博\"被裁硕士生一天打五六千个螺丝\"戳中学历贬值的真相：AI贬值的不是读书无用，而是只靠知识储备吃饭的那部分能力。培训的价值正从\"传授答案\"转向\"训练判断\"。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-job-vanishing-silence",
    "title": "掌握AI时代的「岗位消失静默期」",
    "category": "stable",
    "quiz_url": "/courses/course-ai-job-vanishing-silence/quiz.html",
    "handbook_url": "/courses/course-ai-job-vanishing-silence/handbook.html",
    "articleId": "ai-job-vanishing-silence",
    "summary": "从微博热榜\"中国的小偷为何断崖式下降\"切入：技术替代岗位的本质是场景蒸发，而不是明确裁员。岗位在无人讨论中安静消失，这段静默期没有任何警报，却是唯一的可干预窗口。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-ladder-gone",
    "title": "掌握AI时代的「阶梯消失」",
    "category": "created",
    "quiz_url": "/courses/course-ai-ladder-gone/quiz.html",
    "handbook_url": "/courses/course-ai-ladder-gone/handbook.html",
    "articleId": "ai-ladder-gone",
    "summary": "AI让一个工具包揽初稿、把关和决策，组织里\"从低到高\"的爬升阶梯被抽掉了中间几级。当没人再从基础活里练出判断力，组织的接班梯队正在静默崩塌。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-learning-director",
    "title": "掌握给培训师的一封信：AI时代的\"学习导演\"",
    "category": "stable",
    "quiz_url": "/courses/course-ai-learning-director/quiz.html",
    "handbook_url": "/courses/course-ai-learning-director/handbook.html",
    "articleId": "ai-learning-director",
    "summary": "AI把所有标准答案都变便宜了，培训师靠\"信息差\"吃饭的路已经堵死。真正涨价的，是只有人能教的\"判断力\"。从知识传授者到学习导演，这一步迈过去只会更值钱。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-leave-shame",
    "title": "掌握AI时代的「请假羞耻」",
    "category": "eliminated",
    "quiz_url": "/courses/course-ai-leave-shame/quiz.html",
    "handbook_url": "/courses/course-ai-leave-shame/handbook.html",
    "articleId": "ai-leave-shame",
    "summary": "•请假羞耻：AI让\"你不在场\"毫无代价，于是\"你需要休息\"反而变成需要辩护的\"多余\"\\n•被需要的证据消失：以前\"我一走就乱套\"，现在AI把乱套概率降到零，只能用不休假证明自己有用\\n•三个机制：无缝顶替失去证据、随时在线成默认让离线可疑、人被当\"AI备件\"\\n•代价：全员假装不需要休息——休假时长降40%，核心团队因",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-loss-inertia",
    "title": "掌握AI时代的「亏损惯性」",
    "category": "eliminated",
    "quiz_url": "/courses/course-ai-loss-inertia/quiz.html",
    "handbook_url": "/courses/course-ai-loss-inertia/handbook.html",
    "articleId": "ai-loss-inertia",
    "summary": "三大航上半年合计亏八十多亿上热榜，我想说的不是票务和油价，而是\"亏损惯性\"——缺的不是钱和资源，是推翻旧路径的勇气。深陷惯性的组织会把AI拿去做更高效的旧事，用最先进的工具把最过时的生意做得更亏。AI救不了不想换打法的组织。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-loss-most-fatal",
    "title": "掌握AI时代，组织失去哪种人最致命",
    "category": "stable",
    "quiz_url": "/courses/course-ai-loss-most-fatal/quiz.html",
    "handbook_url": "/courses/course-ai-loss-most-fatal/handbook.html",
    "articleId": "ai-loss-most-fatal",
    "summary": "知乎热榜吵了两千年\"楚汉争霸失去谁对刘邦最致命\"，我把它搬到今天的公司——当AI抹平执行、能力变便宜，过去最贵的\"韩信型执行者\"正在贬值，最便宜的\"张良型判断者\"成了组织命门。可惜多数老板仍按旧尺子裁人：裁光张良留满韩信，高效地做着错事。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-loyalty-inflation",
    "title": "掌握AI时代的「忠诚度通胀」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-loyalty-inflation/quiz.html",
    "handbook_url": "/courses/course-ai-loyalty-inflation/handbook.html",
    "articleId": "ai-loyalty-inflation",
    "summary": "•\"忠诚度通胀\"：不是忠诚变贵了，是忠诚的\"购买力\"贬值了——旧留人筹码正在缩水\\n•跳槽成本=信息成本+关系成本+学习成本，AI已击穿信息成本和学习成本\\n•三大旧武器集体失灵：钱（薪酬透明化失去定价权）、晋升（层级压扁胡萝卜变短）、感情（连接虚拟化失去附着点）\\n•留人三判断：给独特资源不给通用报酬、把晋升换成成长",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-major-course-retreat",
    "title": "掌握AI时代的「主科\"退位」",
    "category": "created",
    "quiz_url": "/courses/course-ai-major-course-retreat/quiz.html",
    "handbook_url": "/courses/course-ai-major-course-retreat/handbook.html",
    "articleId": "ai-major-course-retreat",
    "summary": "从微博热榜\"取消英语主科利弊\"切入：教育在吵要不要取消英语，组织在装睡地问为什么培训没效果。本质是一门课配不配当主科，看它是训练稀缺的底层能力，还是只教一个随时能被AI替代的\"接口\"。会做报表、翻译、操作某系统这类接口型技能被AI一键代劳后，还当全员主科花大量学时就是浪费。组织该给培训清单做\"接口/能力\"体检：接口降级",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-memory-outsourcing",
    "title": "掌握AI时代的「记忆外包」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-memory-outsourcing/quiz.html",
    "handbook_url": "/courses/course-ai-memory-outsourcing/handbook.html",
    "articleId": "ai-memory-outsourcing",
    "summary": "OpenAI的Codex取消上下文压缩换外部记忆，背后是组织正在悄悄患上\"记忆外包\"病。能被外部记忆存下的永远是what和how，存不下why——判断、权衡和放弃。记忆被移出人脑那一刻，组织就从会思考的活体退化成只会查库的档案柜，纠错能力被连根挖掉。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-mentor-break",
    "title": "掌握AI时代的「导师断代」",
    "category": "eliminated",
    "quiz_url": "/courses/course-ai-mentor-break/quiz.html",
    "handbook_url": "/courses/course-ai-mentor-break/handbook.html",
    "articleId": "ai-mentor-break",
    "summary": "新人遇到问题先问AI而不问老师傅，隐性知识这条\"人传人\"的传承链条正在悄悄断掉。经验最终还是要从活人流到活人手里。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-merit-identification",
    "title": "掌握AI时代的「功劳鉴定\"危机」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-merit-identification/quiz.html",
    "handbook_url": "/courses/course-ai-merit-identification/handbook.html",
    "articleId": "ai-merit-identification",
    "summary": "当AI能伪造一切\"功劳\"，你分得清谁在创造价值吗？用旧尺子裁员，裁掉的是未来。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-methodology-bubble",
    "title": "掌握AI时代的「“方法论泡沫”」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-methodology-bubble/quiz.html",
    "handbook_url": "/courses/course-ai-methodology-bubble/handbook.html",
    "articleId": "ai-methodology-bubble",
    "summary": "•当每个AI工具都自带一套方法论，组织正在经历“框架窒息”\\n•方法论泡沫的三层结构：工具绑架、方法论冲突、方法论依赖症\\n•一个真实案例：同一场周会，三套AI方法论轮番上阵，真正讨论业务不到20分钟\\n•一主多辅原则：每个业务线最多用一个方法论类AI工具\\n•好的AI工具让你减少框架来解决问题，坏的工具让你增加框架来",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-motivation-stage-shift",
    "title": "掌握AI时代的「激励分层\"失效」",
    "category": "stable",
    "quiz_url": "/courses/course-ai-motivation-stage-shift/quiz.html",
    "handbook_url": "/courses/course-ai-motivation-stage-shift/handbook.html",
    "articleId": "ai-motivation-stage-shift",
    "summary": "从微博热榜\"小学靠吼初中靠忍高中靠哄大学靠钱\"切入：这套按资历分层的激励配方，底层默认\"能力、心气、贡献跟资历强相关\"。AI让能力和贡献不再跟资历挂钩，一个入职三个月的新人配AI工作流就能产出老员工熬三年才有的东西，于是\"新人靠吼、老人靠哄靠钱\"失去了准星。激励失灵不是钱不够，是你看错了此刻站在你面前的是谁。组织该把激",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-not-working-skill-decay",
    "title": "掌握AI时代的「能力静默流失」",
    "category": "stable",
    "quiz_url": "/courses/course-ai-not-working-skill-decay/quiz.html",
    "handbook_url": "/courses/course-ai-not-working-skill-decay/handbook.html",
    "articleId": "ai-not-working-skill-decay",
    "summary": "从微博热榜\"长期不工作的人会失去什么\"切入：能力不是银行存款而是河流，工作就是那条下雨的河道。AI时代\"做事\"的价值不只是产出，更是维持并训练判断力。长期不工作会悄悄拿走三样东西：被现实打脸的机会、处理麻烦的肌肉、被需要的感觉。组织要做的，是给员工持续\"练手\"的真实场景。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-order-taking-crisis",
    "title": "掌握AI时代的「接单能力\"危机」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-order-taking-crisis/quiz.html",
    "handbook_url": "/courses/course-ai-order-taking-crisis/handbook.html",
    "articleId": "ai-order-taking-crisis",
    "summary": "DeepSeek-V4-Pro让Agent从\"写得好的人\"变成\"能接任务的人\"。当AI终于不掉链子，只会\"接活\"不会\"担责\"的中层正被平权，组织必须把\"能接活\"从晋升标准里划掉。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-org-metabolism",
    "title": "掌握AI时代的「组织代谢病」",
    "category": "stable",
    "quiz_url": "/courses/course-ai-org-metabolism/quiz.html",
    "handbook_url": "/courses/course-ai-org-metabolism/handbook.html",
    "articleId": "ai-org-metabolism",
    "summary": "AI把组织优化到极致稳定，稳定到它再也无法改变。老业务被续命、新人进不来、创新被合理化掉——一个不会代谢的组织，正在从巅峰滑向僵死。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-outsider-manager-exit",
    "title": "掌握AI时代的\"外行经理\"退场",
    "category": "eliminated",
    "quiz_url": "/courses/course-ai-outsider-manager-exit/quiz.html",
    "handbook_url": "/courses/course-ai-outsider-manager-exit/handbook.html",
    "articleId": "ai-outsider-manager-exit",
    "summary": "那些学历光鲜、跨行业空降、对业务一知半解却靠信息差和资源通道吃饭的\"外行经理\"，正在被AI亲手终结。AI抹平了信息差、把判断变贵之后，他只传话不判断的\"中间管理层油膜\"两头落空——装懂的成本变高，真懂的回报变大，价值主义正在回归。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-perfection-outsourcing",
    "title": "掌握AI时代的「完美主义外包」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-perfection-outsourcing/quiz.html",
    "handbook_url": "/courses/course-ai-perfection-outsourcing/handbook.html",
    "articleId": "ai-perfection-outsourcing",
    "summary": "•完美主义外包：AI把\"改到完美\"的成本降到零，却把\"署名\"（敢不敢说这是我做的）的成本抬到极高\\n•宜家效应：人对亲手做的东西评价更高——因为\"是我的\"所以值钱，署名感断裂后没人敢负责\\n•三个机制：产出\"不是我的\"认同感断裂、免费完美拖垮交付速度、太完美没人敢签字\\n•代价：全员\"保险式完美\"——平庸但挑不出错，同",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-performance-fabrication",
    "title": "掌握AI时代的「考核造假」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-performance-fabrication/quiz.html",
    "handbook_url": "/courses/course-ai-performance-fabrication/handbook.html",
    "articleId": "ai-performance-fabrication",
    "summary": "银行员工自掏一万充存款指标，暴露了AI时代绩效管理的危险信号：当系统实时计量、排名、张榜，逼着人\"做数据\"的冲动比以往更强。古德哈特定律被AI放大十倍——越计量越失真。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-perk-inflation",
    "title": "掌握AI时代的「福利通胀」",
    "category": "created",
    "quiz_url": "/courses/course-ai-perk-inflation/quiz.html",
    "handbook_url": "/courses/course-ai-perk-inflation/handbook.html",
    "articleId": "ai-perk-inflation",
    "summary": "从抖音热榜\"你们公司发月饼了吗\"切入：福利一旦变成比较项，就注定越堆越贵、越贵越没用。AI让标准福利毫无门槛、信息透明放大比较、组织焦虑靠加福利止血，三台引擎共同加速通胀。破法是用三类非通胀型福利替代加量竞赛：专属感、成长型、被看见。福利不是成本，是激励信号的载体。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-personal-ip-inflation",
    "title": "掌握AI时代的「个人IP通胀」",
    "category": "eliminated",
    "quiz_url": "/courses/course-ai-personal-ip-inflation/quiz.html",
    "handbook_url": "/courses/course-ai-personal-ip-inflation/handbook.html",
    "articleId": "ai-personal-ip-inflation",
    "summary": "微博热搜\"反诈老陈宣布停更7天挣生活费\"，一个现象级民警IP为生活费停更。背后是一场个人IP的通胀：内容供应被AI打穿，每个IP分到的注意力被无限稀释。\\n•AI没有杀死个人IP，只是把\"影响力\"变成了廉价通货\\n•粉丝数没掉但变现断崖下跌，信任浓度被冲淡\\n•扛得住AI的三类护城河：结果型、关系型、判断型\\n•最容易",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-practice-reversed",
    "title": "掌握AI时代的\"用进废退\"反了",
    "category": "tension",
    "quiz_url": "/courses/course-ai-practice-reversed/quiz.html",
    "handbook_url": "/courses/course-ai-practice-reversed/handbook.html",
    "articleId": "ai-practice-reversed",
    "summary": "从小信到大的一条定律\"用进废退\"，遇上AI后在组织里悄悄反了。真正的危险不是不会用AI，而是用AI代劳了\"本该亲手做\"的动作——写作、拆解、决策这些练底层能力的苦功夫全被外包，表层技能人人会且快速贬值，底层能力却因常年不练而萎缩。AI可以替你跑，但跑不替你长肌肉。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-preparation-ocd",
    "title": "掌握AI时代的「准备洁癖」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-preparation-ocd/quiz.html",
    "handbook_url": "/courses/course-ai-preparation-ocd/handbook.html",
    "articleId": "ai-preparation-ocd",
    "summary": "微博热搜\"做事千万不要有状态洁癖\"戳中了AI时代最隐蔽的管理陷阱：AI让准备成本归零，人反而可以无限\"再来一版\"，永远在准备、永远没开始。\\n•状态洁癖的本质是对\"不完美\"的恐惧，而非懒\\n•AI让准备工作从\"昂贵\"变\"免费\"，免费的东西最让人上瘾\\n•真实失败反馈的价值，超过一百份完美预案\\n•三个破法：分清必须准备",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-pretend-work",
    "title": "掌握AI时代的「假装上班」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-pretend-work/quiz.html",
    "handbook_url": "/courses/course-ai-pretend-work/handbook.html",
    "articleId": "ai-pretend-work",
    "summary": "从微博热榜\"失业者假装上班挤满图书馆\"切入：失业最痛的不是钱断，是\"我是谁\"这个锚被抽走——人领的不只是工资，还有身份、秩序、意义三样。AI让失业变得\"无声\"：岗位被流程悄悄包走、不裁不补不声张，很多人还\"在职\"但真活已全被AI做完被架空。假装上班是心理与身份危机的笨办法，管理者的责任不在嘲笑，而在学会体面地送人走——",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-pricing-anxiety",
    "title": "掌握AI时代的「定价焦虑」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-pricing-anxiety/quiz.html",
    "handbook_url": "/courses/course-ai-pricing-anxiety/handbook.html",
    "articleId": "ai-pricing-anxiety",
    "summary": "AI越便宜，组织的决策成本反而越贵。峰谷定价不是价格问题，是组织问题：它逼你看清自己是不是一个\"算力散户\"。三层成本：显性（账单）、机会（调度窗口）、决策（无脑用积累的浪费）。解法是让AI从免费赋能工具变成需要被经营的资产——看清、调度、定价。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-queue-premium",
    "title": "掌握AI时代的「排队溢价」",
    "category": "stable",
    "quiz_url": "/courses/course-ai-queue-premium/quiz.html",
    "handbook_url": "/courses/course-ai-queue-premium/handbook.html",
    "articleId": "ai-queue-premium",
    "summary": "当所有商家用AI把体验做到极快，那个愿意慢一点、把你当人看的反而成了稀缺品。胖东来排的不是队，是\"被认真对待\"的人情味——AI替代不了的护城河。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-quiet-departure-warning",
    "title": "掌握AI时代的「隐形离职\"预警」",
    "category": "created",
    "quiz_url": "/courses/course-ai-quiet-departure-warning/quiz.html",
    "handbook_url": "/courses/course-ai-quiet-departure-warning/handbook.html",
    "articleId": "ai-quiet-departure-warning",
    "summary": "从\"工位上的假装上班\"给管理者提个醒：假装上班不是态度问题，是结果——它是\"心理离职\"跑到终点的样子，前面还有热情熄灭、投入收缩、沉默抗议的漫长过程。几乎没有真·突然离职，信号早在几个月前发过，只是被当成\"他最近状态不好\"。AI时代更难识别，因为AI把投入度、产出痕迹这些旧产能信号全包装漂亮、替\"假装者\"打了掩护；真信",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-referral-culture-gone",
    "title": "掌握AI时代的「内推文化\"消亡」",
    "category": "eliminated",
    "quiz_url": "/courses/course-ai-referral-culture-gone/quiz.html",
    "handbook_url": "/courses/course-ai-referral-culture-gone/handbook.html",
    "articleId": "ai-referral-culture-gone",
    "summary": "•内推本质是\"信任的传递\"，解决的是招聘里最贵的问题——信息不对称\\n•算法瓦解内推的三个支点：行为数据更全面、匹配精度更客观、背书价值被去中介化\\n•内推致命缺陷：用\"关系半径\"代替\"能力半径\"，圈子高度同质化\\n•算法替代不了的：\"好不好共事\"的判断——隐性合作性，AI测不出来\\n•改造方案：内推从\"入口\"挪到\"出",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-responsibility-quicksand",
    "title": "掌握AI时代的「责任流沙」",
    "category": "eliminated",
    "quiz_url": "/courses/course-ai-responsibility-quicksand/quiz.html",
    "handbook_url": "/courses/course-ai-responsibility-quicksand/handbook.html",
    "articleId": "ai-responsibility-quicksand",
    "summary": "•\"责任流沙\"：AI参与决策后，决策权被分担但责任无处附着，形成责任真空\\n•问题比\"甩锅\"严重十倍：甩锅起码知道锅在哪，责任流沙让锅不见了\\n•三个正在发生的场景：招聘AI背锅、AI定价的无人认领、AI项目失败的集体推卸\\n•心理根源：\"责任转移本能\"——人本能地把责任让渡给看起来会思考的AI\\n•对抗四步法：责任声",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-reunion-tax",
    "title": "掌握AI时代的「团圆税」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-reunion-tax/quiz.html",
    "handbook_url": "/courses/course-ai-reunion-tax/handbook.html",
    "articleId": "ai-reunion-tax",
    "summary": "从微博热榜\"今年中秋节我就不回家了\"切入：当\"在一起\"从必须变成可选，组织就会在效率算盘上第一个砍掉它。但隐性知识、弱关系、共同语境，都长在那些算不清账的\"一起\"里。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-review-inflation",
    "title": "掌握AI时代的「复盘通胀」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-review-inflation/quiz.html",
    "handbook_url": "/courses/course-ai-review-inflation/handbook.html",
    "articleId": "ai-review-inflation",
    "summary": "AI让复盘变得前所未有的完整，纪要齐全、数据齐备。但复盘产量暴增的同时，价值在悄悄贬值——复盘的目的是消化而不是记录。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-risk-arrogance",
    "title": "掌握AI时代的「风险傲慢」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-risk-arrogance/quiz.html",
    "handbook_url": "/courses/course-ai-risk-arrogance/handbook.html",
    "articleId": "ai-risk-arrogance",
    "summary": "微博热搜\"比尔盖茨发12页长文警告AI风险\"暴露一个组织病：红利太诱人、从众心理、风险被外包，让组织对近在眼前的AI风险集体麻痹。破局靠风险清单、人工刹车、小步验证——正视风险，才能更稳吃红利。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-secondhand-experience",
    "title": "掌握AI时代的「经验二手化」",
    "category": "eliminated",
    "quiz_url": "/courses/course-ai-secondhand-experience/quiz.html",
    "handbook_url": "/courses/course-ai-secondhand-experience/handbook.html",
    "articleId": "ai-secondhand-experience",
    "summary": "AI时代的\"经验二手化\"——当经验都来自AI总结，没人再亲历过任何事 上周面试一个干了五年的运营主管，聊到一个具体的项目复盘，他讲得头头是道：渠道成本、转化漏斗、A/B测试、归因模型，逻辑严谨，术语精准。 他愣了一下，然后诚实地说：\"这个……我是看AI总结的复盘报告知道的。当时那个项目我其实没深度参与。\"",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-shift-scheduling-illusion",
    "title": "掌握AI时代的「排班幻觉」",
    "category": "stable",
    "quiz_url": "/courses/course-ai-shift-scheduling-illusion/quiz.html",
    "handbook_url": "/courses/course-ai-shift-scheduling-illusion/handbook.html",
    "articleId": "ai-shift-scheduling-illusion",
    "summary": "从微博热榜\"上5休1上5休3上3休7上3休1\"调休方案切入：排班的本质不是填满工位，是把一群会累、需要连续性的活人安排进有节奏的时间。AI排班只优化可计算的效率，把\"人的节奏感\"当噪声滤掉，于是得到数学满分、体验崩溃的排班表。三道代价：碎片化休息恢复不了精力、组织节奏被打散隐藏协作成本、剥夺可预期性侵蚀主动性。破法：连",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-signal-noise-trap",
    "title": "掌握AI时代的「“信号噪声陷阱”」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-signal-noise-trap/quiz.html",
    "handbook_url": "/courses/course-ai-signal-noise-trap/handbook.html",
    "articleId": "ai-signal-noise-trap",
    "summary": "•AI监测能力太强，一天生成347条告警，管理者却一条都不想看了\\n•从“信息匮乏”到“信号过剩”的转型，管理者还在用旧思维\\n•三个真实场景：绩效异常、舆情监控、项目预警中的“狼来了”效应\\n•AI是完美的告警器，但它是糟糕的优先级排序器\\n•核心判断：学会忽略比学会关注更难，但在AI时代更重要",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-slogan-words-retreat",
    "title": "掌握AI时代的「口号空转」",
    "category": "eliminated",
    "quiz_url": "/courses/course-ai-slogan-words-retreat/quiz.html",
    "handbook_url": "/courses/course-ai-slogan-words-retreat/handbook.html",
    "articleId": "ai-slogan-words-retreat",
    "summary": "从抖音热榜教育部\"尊师重教不能只是词语口号\"切入：口号本质是低成本的价值表态，过去因为查证成本极高所以有用。AI把人的真实行为变成可记录、可对比、随时可戳穿的数据，言行不一的落差藏不住了，口号从低成本保险变成高风险负债。只会喊口号的组织会付出三笔代价：价值口号被AI实时打脸、最优秀员工用脚投票、真本事退场表演家上位。破",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-sparring-training",
    "title": "掌握AI时代的「陪练型培训」",
    "category": "stable",
    "quiz_url": "/courses/course-ai-sparring-training/quiz.html",
    "handbook_url": "/courses/course-ai-sparring-training/handbook.html",
    "articleId": "ai-sparring-training",
    "summary": "纯粹靠\"讲知识\"的培训师越来越危险，但换个活法会迎来新红利——陪练型培训。\\n•AI已把\"知识传授\"这一关打穿，信息差归零\\n•学员缺的不是知识，是能力；能力只能靠\"练\"\\n•知识付费在坍塌，但\"陪练\"在涨价（健身私教逻辑）\\n•陪练三层手感：练判断、练表达、练临场\\n•三个转型动作：砍一半讲、做沉默观察者、设计有压力",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-staffing-bankruptcy",
    "title": "掌握AI时代的\"编制思维\"破产",
    "category": "eliminated",
    "quiz_url": "/courses/course-ai-staffing-bankruptcy/quiz.html",
    "handbook_url": "/courses/course-ai-staffing-bankruptcy/handbook.html",
    "articleId": "ai-staffing-bankruptcy",
    "summary": "GPT-6正式发布炸了全网，我却在担心一件更深的旧东西：组织的\"编制思维\"。当AI让一个人+一堆agent能顶一个小团队，组织还按\"人头数=战斗力\"配预算、定晋升、画汇报线，就会配多了养闲人、配少了卡死顶梁柱。编制不会一夜消失，但\"人头越多越强\"的旧信仰该破产了——钱要跟着\"能力当量\"走，而不是跟着人头走。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-strategy-reorg-loyalty",
    "title": "掌握AI时代的「战略重锤」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-strategy-reorg-loyalty/quiz.html",
    "handbook_url": "/courses/course-ai-strategy-reorg-loyalty/handbook.html",
    "articleId": "ai-strategy-reorg-loyalty",
    "summary": "从知乎热榜\"字节将飞书并入豆包，张一鸣称史上最大押注\"切入：组织架构的稳定性由战略的确定性决定。战略变成豪赌，架构就从大楼变成随时可重拼的乐高。独立BU成奢侈品、组织忠诚是单向的、重组速度即竞争力——被重锤砸到的人，最该绑在能力和关系上，而不是部门和title上。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-sunk-cost-trap",
    "title": "掌握AI时代的「沉没成本」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-sunk-cost-trap/quiz.html",
    "handbook_url": "/courses/course-ai-sunk-cost-trap/handbook.html",
    "articleId": "ai-sunk-cost-trap",
    "summary": "从知乎热榜\"河南40岁数学老师自费300万拍电影票房仅2.4万\"切入：人停不下来，不是因为看不清该停，而是\"再往前一步\"的成本被AI削到近乎为零。AI最擅长把已在做的事做得更好，却永远不会告诉你此事不该做。三种对抗方式：预设退出条件而非继续理由、把沉没成本从决策桌拿走、让AI执行而让制度叫停。判断力最稀缺的时刻是决定何",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-task-followthrough",
    "title": "掌握AI时代的「任务手尾\"正在消失」",
    "category": "eliminated",
    "quiz_url": "/courses/course-ai-task-followthrough/quiz.html",
    "handbook_url": "/courses/course-ai-task-followthrough/handbook.html",
    "articleId": "ai-task-followthrough",
    "summary": "AI能从头干到尾，但\"干完\"和\"干净\"是两回事。当组织只奖励交付速度、不为\"手尾质量\"付钱，丢掉的不是几个岗位，而是整个组织的长期免疫系统。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-teacher-role",
    "title": "掌握AI时代的「知识交付\"退场」",
    "category": "stable",
    "quiz_url": "/courses/course-ai-teacher-role/quiz.html",
    "handbook_url": "/courses/course-ai-teacher-role/handbook.html",
    "articleId": "ai-teacher-role",
    "summary": "从微博热榜\"AI或可替代教师只需一个班主任\"切入：被AI替代的不是教师，而是\"知识交付\"这一层。组织培训要重估的是陪伴、练习与信任这些AI给不了的部分。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-team-building-paradox",
    "title": "掌握AI时代的「团建悖论」",
    "category": "eliminated",
    "quiz_url": "/courses/course-ai-team-building-paradox/quiz.html",
    "handbook_url": "/courses/course-ai-team-building-paradox/handbook.html",
    "articleId": "ai-team-building-paradox",
    "summary": "热搜\"公司组织无人岛游玩被罚11万\"背后，是一场组织人味危机：AI优化掉了日常的关系缝隙，组织被迫把\"凝聚\"挤压到猎奇的仪式里，越用力越翻车。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-textbook-anxiety",
    "title": "掌握AI时代的「教材更替焦虑」",
    "category": "created",
    "quiz_url": "/courses/course-ai-textbook-anxiety/quiz.html",
    "handbook_url": "/courses/course-ai-textbook-anxiety/handbook.html",
    "articleId": "ai-textbook-anxiety",
    "summary": "知乎热榜\"全国中小学新教材将全部替换\"暴露组织学习的错位：教材是慢变量可以系统换版，AI技能是快变量必须永续更新。越认真做\"标准教材\"越跟不上。破局：把教材改成活文档、用实战任务替代集中考试培训、重点培养\"学会学习\"的能力。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-token-threshold",
    "title": "掌握AI时代的「Token门槛」",
    "category": "tension",
    "quiz_url": "/courses/course-ai-token-threshold/quiz.html",
    "handbook_url": "/courses/course-ai-token-threshold/handbook.html",
    "articleId": "ai-token-threshold",
    "summary": "知乎热榜七百万热度的\"没Token就退学\"背后，是AI时代一道新的资源门槛。算力成为新时代生产资料，组织里的\"有Token者\"和\"没Token者\"正在分裂成两个物种，而管理者往往用Token差异给员工能力打分。拆门槛的关键，是把算力当基础设施、把资源差异从绩效剥离。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-tool-iteration-stall",
    "title": "掌握AI时代的「工具失速」",
    "category": "eliminated",
    "quiz_url": "/courses/course-ai-tool-iteration-stall/quiz.html",
    "handbook_url": "/courses/course-ai-tool-iteration-stall/handbook.html",
    "articleId": "ai-tool-iteration-stall",
    "summary": "技术更新是指数级的，组织消化是线性的，落差就是\"工具失速\"。三个代价：沉没成本堆积、工具割裂、学习动力被透支。最怕的不是跟不上，而是不想跟了。解法是踩自己的节奏：设更新窗口期、区分先用和练熟、把稳定当竞争壁垒。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-trust-harvest",
    "title": "掌握AI时代的「信任收割」",
    "category": "eliminated",
    "quiz_url": "/courses/course-ai-trust-harvest/quiz.html",
    "handbook_url": "/courses/course-ai-trust-harvest/handbook.html",
    "articleId": "ai-trust-harvest",
    "summary": "知乎\"男子省吃俭用20年攒789万6天被骗空\"揭示：攒钱靠自动，被骗靠被接管。AI一边让骗局更精致，一边让人丧失独立判断。判断力越外包越萎缩，独立思考成了AI时代最稀缺的能力。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-veto-vacuum",
    "title": "掌握AI时代的「否决权真空」",
    "category": "stable",
    "quiz_url": "/courses/course-ai-veto-vacuum/quiz.html",
    "handbook_url": "/courses/course-ai-veto-vacuum/handbook.html",
    "articleId": "ai-veto-vacuum",
    "summary": "AI让提案供过于求，却让最关键的否决能力出现真空。敢于说\"不\"的判断力，成了AI时代组织最稀缺的硬通货。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-why-not-fake-work",
    "title": "掌握AI时代的「AI时代，凭什么让员工不想\"假装上班\"？」",
    "category": "stable",
    "quiz_url": "/courses/course-ai-why-not-fake-work/quiz.html",
    "handbook_url": "/courses/course-ai-why-not-fake-work/handbook.html",
    "articleId": "ai-why-not-fake-work",
    "summary": "承接\"假装上班\"主题，讲给还在工位上、但已悄悄在\"假装\"的在职者与管理者。本质是一个人开始装，是因为工作不再\"养\"他——钱、成长、意义三样长期断供就\"挂机\"。盯梢打卡在AI时代彻底失灵，因为AI让\"产出\"好观察又易造假，甚至产生\"逆向淘汰\"：越会装的人越能借AI包装自己，组织在奖励\"会装\"惩罚\"肯干\"。破局是从\"管投入",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
  },
  {
    "id": "course-ai-cognition-debt",
    "title": "掌握AI时代的「认知负债」",
    "category": "stable",
    "quiz_url": "/courses/course-ai-cognition-debt/quiz.html",
    "handbook_url": "/courses/course-ai-cognition-debt/handbook.html",
    "articleId": "ai-cognition-debt",
    "summary": "食堂能做1000人的饭，却不知道米饭该怎么做。AI让组织借来效率、抵押理解。这套测评帮你摸清认知负债的账面。",
    "modules": 1,
    "audience": "管理者、团队负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-compensation-escape",
    "title": "掌握AI时代的「赔偿逃生」",
    "category": "eliminated",
    "quiz_url": "/courses/course-ai-compensation-escape/quiz.html",
    "handbook_url": "/courses/course-ai-compensation-escape/handbook.html",
    "articleId": "ai-compensation-escape",
    "summary": "宝马裁8000人给65万欧，高补偿买的不是良心是加速费。裁员是手术，转岗是康复，只做手术不做康复，病人看着轻了其实废了。",
    "modules": 1,
    "audience": "管理者、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
  {
    "id": "course-ai-paper-trace",
    "title": "掌握AI时代的「过程留痕」",
    "category": "created",
    "quiz_url": "/courses/course-ai-paper-trace/quiz.html",
    "handbook_url": "/courses/course-ai-paper-trace/handbook.html",
    "articleId": "ai-paper-trace",
    "summary": "AI痕迹的本质是过程真空。组织最该留的是判断的痕迹，不是行为的监控。留错方向，等于白留。",
    "modules": 1,
    "audience": "管理者、团队负责人、HR负责人",
    "tags": [
        "AI",
        "组织效率"
    ]
},
];
